export const common = {
  // Navegação
  'nav.features': 'Funcionalidades',
  'nav.howItWorks': 'Como funciona',
  'nav.pricing': 'Preços',
  'nav.faq': 'FAQ',
  'nav.aboutUs': 'Sobre Nós',
  'nav.getStarted': 'Começar',

  // Seção Sobre Nós
  'aboutUs.badge': "Sobre nós",
  'aboutUs.title': "Por que existe a IdeaVerdict",
  'aboutUs.line1': "Qualquer um pode ter uma ideia.",
  'aboutUs.line2': "Poucos admitem que a deles não se sustenta.",
  'aboutUs.paragraph1':
    "A maioria das ideias não falha por falta de coragem. Falha porque ninguém disse a verdade a tempo. IdeaVerdict fecha essa lacuna — damos o veredicto brutal que seus amigos não darão.",
  'aboutUs.belief1a': "Não negociamos com hype.",
  'aboutUs.belief1b': "Negociamos com sinais de mercado.",
  'aboutUs.belief2a': "Não vendemos motivação.",
  'aboutUs.belief2b': "Vendemos uma leitura clara de demanda, concorrência e viabilidade.",
  'aboutUs.mission1': "Nosso trabalho não é fazer sua ideia parecer boa.",
  'aboutUs.mission2': "Nosso trabalho é dizer se ela é.",
  'aboutUs.analysis':
    "IdeaVerdict avalia ideias no que importa — estrutura de mercado, demanda real, concorrência, capital necessário, time-to-revenue, escalabilidade. Sem emoção. Sem otimismo. Apenas análise.",
  'aboutUs.failure1': "A maioria das empresas falha.",
  'aboutUs.failure2': "Não porque as pessoas atrás fossem incompetentes —",
  'aboutUs.failure3': "mas porque ninguém contestou com força suficiente, a tempo.",
  'aboutUs.clarity': "Existimos para contestar.",
  'aboutUs.value1': "Direto.",
  'aboutUs.value2': "Honesto.",
  'aboutUs.value3': "Rápido.",
  'aboutUs.confirm': "Se sua ideia tem substância, nós a apoiamos.",
  'aboutUs.deny': "Se não, dizemos na cara.",
  'aboutUs.noApplause': "Sem aplausos.",
  'aboutUs.noSugarcoating': "Sem suavização.",
  'aboutUs.noTheater': "Sem teatro.",
  'aboutUs.noHype': "Apenas o veredicto.",
  // Seção Hero
  'hero.badge': 'Veredicto de IA em menos de 60 segundos',
  'hero.title1': 'Não construa',
  'hero.title2': 'antes de verificar.',
  'hero.subtitle': 'IdeaVerdict testa sua ideia como um VC cético.',
  'hero.subtitleLine2': 'Veredicto honesto em segundos — sem hype, sem bajulação.',
  'hero.cta': 'Obter meu veredicto',
  'hero.ctaSecondary': 'Veja como funciona',
  'hero.stat1Value': '30',
  'hero.stat1Label': 'Créditos por consulta',
  'hero.stat2Value': 'A partir de 7',
  'hero.stat2Label': 'Dimensões de avaliação',
  'hero.stat3Value': '100%',
  'hero.stat3Label': 'Honesto e Privado',

  // Seção Funcionalidades
  'features.title1': 'Feito para',
  'features.title2': 'fundadores que',
  'features.title3': 'querem a verdade',
  'features.bullet1.title': 'Veredicto honesto em segundos',
  'features.bullet1.description':
    'Forte, Misto ou Fraco — com o raciocínio por trás. Sem aplausos, sem adoçar, sem teatro.',
  'features.bullet2.title': 'Avaliado pelo que importa',
  'features.bullet2.description':
    'Sua ideia é avaliada por demanda real, concorrência, capital necessário, tempo até a receita e escalabilidade — não por impressões.',
  'features.bullet3.title': 'Do veredicto à construção',
  'features.bullet3.description':
    'O modo Builder transforma uma ideia aprovada em um briefing para devs: fluxos de usuário, funcionalidades principais, notas técnicas.',

  // Como Funciona
  'howItWorks.title': 'Como funciona',
  'howItWorks.subtitle': 'Da ideia ao veredicto — quatro passos, dez minutos.',
  'howItWorks.step1Title': 'Escolha seu plano',
  'howItWorks.step1Desc': 'Starter, Pro ou Builder — escolha a profundidade que você precisa.',
  'howItWorks.step2Title': 'Descreva sua ideia',
  'howItWorks.step2Desc': 'Conte à IA o que você está construindo. Cada veredicto custa 30 créditos.',
  'howItWorks.step3Title': 'Receba o veredicto',
  'howItWorks.step3Desc': 'Três notas possíveis: Forte, Misto ou Fraco. Com o raciocínio por trás.',
  'howItWorks.step4Title': 'Decida o próximo passo',
  'howItWorks.step4Desc': 'Construir, pivotar ou seguir — com sinal real, não intuição.',

  // Preços
  'pricing.title': 'Preços',
  'pricing.subtitle': 'Escolha o plano que se adequa à profundidade da sua análise.',
  'pricing.monthly': 'Mensal',
  'pricing.yearly': 'Anual',
  'pricing.yearlyDiscount': 'Assinatura anual:',
  'pricing.yearlyDiscountValue': '-20% de desconto',
  'pricing.perMonth': 'por mês',
  'pricing.selectPlan': 'Selecionar Plano',
  'pricing.mostPopular': 'Mais Popular',
  'pricing.footer':
    'Todos os preços em CHF. Os créditos são debitados apenas para respostas bem-sucedidas da IA.',

  // Pricing Features
  'pricing.feature1': 'Gerar ideia de nicho',
  'pricing.feature2': 'Refinar nicho',
  'pricing.feature3': 'Verificação de realidade de mercado',
  'pricing.feature4': 'Avaliação da concorrência',
  'pricing.feature5': 'Avaliação de tempo',
  'pricing.feature6': 'Veredito honesto',
  'pricing.feature7': 'Sessões privadas',
  'pricing.feature8': 'Histórico e exportação',
  'pricing.feature9': 'Ideias de nicho',
  'pricing.feature10': 'Análise de tendências',
  'pricing.feature11': 'Sugestões de melhoria',
  'pricing.feature12': 'Nichos alternativos',
  'pricing.feature13': 'Análise de mercado detalhada',
  'pricing.feature14': 'Suporte prioritário',
  'pricing.feature15': 'Filtros avançados',
  'pricing.feature16': 'Sessões favoritas',
  'pricing.feature17': 'Alertas Analíticos',
  'pricing.feature18': 'Gerente de Sucesso Pessoal',

  // Plano Starter
  'pricing.starter.name': 'Starter',
  'pricing.starter.price': '39.90',
  'pricing.starter.description': 'Acesso ao chatbot de nicho por IA',
  'pricing.starter.credits': '2.500 Créditos por mês',
  'pricing.starter.feature1': 'Gerar ideia de nicho',
  'pricing.starter.feature2': 'Refinar nicho',
  'pricing.starter.feature3': 'Verificação de realidade de mercado',
  'pricing.starter.feature4': 'Avaliação da concorrência',
  'pricing.starter.feature5': 'Avaliação de tempo',
  'pricing.starter.feature6': 'Veredito honesto',
  'pricing.starter.feature7': 'Sessões privadas',
  'pricing.starter.feature8': 'Histórico e exportação',

  // Plano Pro
  'pricing.pro.name': 'Pro',
  'pricing.pro.price': '59.90',
  'pricing.pro.description': 'Acesso ao chatbot de nicho por IA',
  'pricing.pro.credits': '5.000 Créditos por mês',
  'pricing.pro.feature1': 'Todas as funcionalidades do Starter',
  'pricing.pro.feature2': 'Mais créditos para análise intensiva',
  'pricing.pro.feature3': 'Sugestões de melhoria',
  'pricing.pro.feature4': 'Nichos alternativos',
  'pricing.pro.feature5': 'Análise de mercado detalhada',
  'pricing.pro.feature6': 'Suporte prioritário',
  'pricing.pro.feature7': 'Filtros avançados',
  'pricing.pro.feature8': 'Sessões favoritas',

  // Plano Builder
  'pricing.builder.name': "Builder",
  'pricing.builder.price': '199',
  'pricing.builder.description': "Todas as funções + modo Builder",
  'pricing.builder.credits': "10.000 créditos por mês",
  'pricing.builder.feature1': 'Todas as funcionalidades do Pro',
  'pricing.builder.feature2': 'Consultas de IA ilimitadas',
  'pricing.builder.feature3': 'Modo Builder: Briefings para desenvolvedores',
  'pricing.builder.feature4': 'Visão geral estruturada do projeto',
  'pricing.builder.feature5': 'Fluxos de usuário e funcionalidades principais',
  'pricing.builder.feature6': 'Notas técnicas',
  'pricing.builder.feature7': 'Definir não-objetivos',
  'pricing.builder.feature8': 'Limite de uso justo',
  'pricing.builder.limitNote': 'Limite de uso justo',
  'pricing.monthlyReset': 'Reinicialização mensal',

  // Modal
  'pricing.modal.selected': 'selecionado',
  'pricing.modal.comingSoon':
    'Registro e processamento de pagamento estarão disponíveis em breve.',
  'pricing.modal.patience':
    'Estamos trabalhando para lhe proporcionar uma experiência segura e perfeita. Por favor, seja paciente.',
  'pricing.modal.understood': 'Compreendido',

  // FAQ
  'faq.title': 'FAQ',
  'faq.subtitle': 'Respostas diretas, sem marketing.',
  'faq.q1': "O que a IdeaVerdict realmente faz?",
  'faq.a1': "Avalia sua ideia de negócio no que decide o sucesso — demanda real, concorrência, capital, time-to-market e escalabilidade.\nSe a ideia se sustenta, mostramos como afiá-la.\nSe não, também dizemos.",
  'faq.q2': "Vocês também geram ideias?",
  'faq.a2': "Sim — mas não sugestões aleatórias.\nIdeias vêm de lacunas reais de mercado, não do que está em alta esta semana.",
  'faq.q3': "Vocês melhoram modelos de negócio existentes?",
  'faq.a3': "Sim, se há algo para melhorar.\nNão polimos ideias quebradas — fortalecemos as que já têm base.",
  'faq.q4': "Como vocês são diferentes de outras ferramentas de IA?",
  'faq.a4': "A maioria das ferramentas de IA diz que sua ideia é ótima.\nNós dizemos se ela realmente é.\nA diferença: realismo em vez de entusiasmo.",
  'faq.q5': "Isso garante sucesso?",
  'faq.a5': "Não.\nAjudamos você a evitar apostas ruins — o risco não desaparece, mas você entra de olhos abertos.",
  'faq.q6': "Para quem é a IdeaVerdict?",
  'faq.a6': "Fundadores antes do lançamento.\nBuilders antes do side-project do fim de semana.\nOperators antes da próxima aposta.\nInvestidores antes da assinatura.\n\nPara quem quer clareza antes do compromisso.",
  'faq.q7': "E se eu só quiser validação?",
  'faq.a7': "Então a IdeaVerdict é a ferramenta errada.\nEntregamos veredicto honesto, não conforto.",
  'faq.q8': "Quão honesta é a análise realmente?",
  'faq.a8': "Tão honesta quanto os dados permitem.\nNão suavizamos um veredicto fraco para poupar sentimentos.",
  'faq.q9': "Isso substitui uma pesquisa de mercado real?",
  'faq.a9': "Não.\nÉ um check estratégico rápido antes de investir — não um estudo de 50 páginas.",
  'faq.q10': "Por que tão diretos?",
  'faq.a10': "Porque construir a coisa errada custa meses.\nUm veredicto honesto custa minutos.\n\nEscolhemos os minutos.",
  // Rodapé
  'footer.description':
    'IdeaVerdict não está aqui para te fazer sentir bem. Está aqui para te ajudar a decidir certo.',
  'footer.product': 'Produto',
  'footer.aiAssistant': 'Assistente IA',
  'footer.howItWorks': 'Como funciona',
  'footer.pricing': 'Preços',
  'footer.faq': 'FAQ',
  'footer.legal': 'Legal',
  'footer.privacy': 'Privacidade',
  'footer.terms': 'Termos',
  'footer.imprint': 'Impressão',
  'footer.support': 'Suporte',
  'footer.contact': 'Contato',
  'footer.documentation': 'Documentação',
  'footer.copyright': '© 2026 IdeaVerdict. Todos os direitos reservados.',

  // Assistente IA
  'aiAssistant.title': 'Assistente IA de Nichos',
  'aiAssistant.subtitle': 'Pergunte sobre nichos',
  'aiAssistant.welcomeMessage':
    'Olá! Descreva sua ideia ou pergunte-me sobre um nicho. Darei uma avaliação clara e honesta.',
  'aiAssistant.demoResponse':
    'Isto é uma demonstração. Para obter avaliações reais da IA, por favor registre-se e escolha um plano.',
  'aiAssistant.placeholder': 'Descreva sua ideia...',

  // Cabeçalho e Barra Lateral
  'dashboard.header.title': 'Painel',
  'dashboard.header.aiAssistant': 'Seu Assistente IA',
  'header.logout': 'Sair',
  'dashboard.sidebar.overview': 'Visão Geral',
  'dashboard.sidebar.aiChat': 'Assistente IA',
  'dashboard.sidebar.newAnalysis': 'Assistente IA',
  'dashboard.sidebar.history': 'Histórico',
  'dashboard.sidebar.credits': 'Créditos',
  'dashboard.sidebar.settings': 'Configurações',

  // Visão Geral do Painel
  'dashboard.overview.welcome': 'Bem-vindo de volta, {{name}}',
  'dashboard.overview.subtitle':
    'Aqui está uma visão rápida da sua atividade',

  // Estatísticas do Painel
  'dashboard.stats.creditsRemaining': 'Créditos restantes',
  'dashboard.stats.totalAnalyses': 'Total de análises',
  'dashboard.stats.goodRatings': 'Avaliações positivas',
  'dashboard.stats.nextReset': 'Próxima reinicialização em',
  'dashboard.stats.days': 'dias',

  // Ações Rápidas
  'dashboard.quickActions.title': 'Ações rápidas',
  'dashboard.quickActions.checkNewIdea': 'Analisar uma ideia',
  'dashboard.quickActions.checkNewIdeaDesc':
    'Analisar uma ideia de negócio existente',
  'dashboard.quickActions.generateIdea': 'Gerar uma ideia',
  'dashboard.quickActions.generateIdeaDesc':
    'Encontrar um novo nicho lucrativo',
  'dashboard.quickActions.builderBriefing': 'Briefing do Builder',
  'dashboard.quickActions.builderBriefingDesc':
    'Transformar uma ideia em um briefing pronto para desenvolvedor',
  'dashboard.quickActions.premiumOnly': 'Apenas Builder',

  // Cabeçalho do Chat
  'chat.title': 'Assistente IA de Nichos',
  'chat.subtitle':
    'Faça perguntas sobre nichos. Avalio de forma crítica e honesta.',
  'chat.creditsLabel': 'Créditos',

  // Boas-vindas do Chat
  'chat.welcomeTitle': 'Bem-vindo ao Assistente IA de Nichos',
  'chat.welcomeDesc':
    'Descreva sua ideia ou pergunte sobre um nicho. Eu o avaliarei honestamente: Bom, Médio ou Ruim.',
  'chat.aiWelcome':
    'Olá! Descreva sua ideia ou pergunte-me sobre um nicho. Darei uma avaliação clara e honesta.',

  // Sugestões do Chat
  'chat.suggestion1': 'Quero criar uma ferramenta SaaS para freelancers gerenciarem faturas. É um bom nicho?',
  'chat.suggestion2': 'Encontre-me um negócio online com pouca concorrência que eu possa começar com $500 sem saber programar.',
  'chat.suggestion3': 'Avalie isso: um app de planejamento de refeições com IA para pais ocupados com restrições alimentares.',
  'chat.suggestion4': 'Quero vender templates digitais no Etsy para pequenos empresários. Analise este nicho honestamente.',

  // Ações do Chat
  'chat.newConversation': 'Nova conversa',
  'chat.today': 'Hoje',
  'chat.yesterday': 'Ontem',
  'chat.thisWeek': 'Esta semana',
  'chat.thisMonth': 'Este mês',
  'chat.older': 'Mais antigas',
  'chat.messages': 'mensagens',
  'chat.renameConversation': 'Renomear',
  'chat.deleteConversation': 'Excluir',
  'chat.cancel': 'Cancelar',
  'chat.rename': 'Renomear',
  'chat.delete': 'Excluir',
  'chat.favorite': 'Adicionar aos favoritos',
  'chat.unfavorite': 'Remover dos favoritos',
  'chat.searchSessions': 'Pesquisar conversas...',
  'chat.noResults': 'Nenhum resultado encontrado',
  'chat.noSessions': 'Nenhuma conversa ainda',
  'chat.enterNewName': 'Digite o novo nome...',
  'chat.deleteConfirmMessage':
    'Tem certeza que deseja excluir esta conversa? Esta ação não pode ser desfeita.',

  // Entrada do Chat e Erros
  'chat.inputPlaceholder': 'Digite sua pergunta… (custa 30 créditos)',
  'chat.send': 'Enviar',
  'chat.voice': 'Falar',
  'chat.listeningPlaceholder': 'Estou ouvindo... Fale agora.',
  'chat.stopListening': 'Parar de ouvir',
  'chat.recording': 'Gravando...',
  'chat.speechNotSupported': 'Seu navegador não suporta reconhecimento de voz.',
  'chat.microphonePermissionDenied': 'Acesso ao microfone negado. Permita o acesso nas configurações do navegador.',
  'chat.errorNotEnoughCredits':
    'Créditos insuficientes. Faça upgrade do seu plano ou aguarde a próxima reinicialização.',
  'chat.errorAiFailed': 'Falha na resposta da IA. Nenhum crédito foi debitado.',
  'chat.errorRateLimit': 'Muitas solicitações. Aguarde um momento.',

  // Avaliações
  'rating.good': 'Bom',
  'rating.medium': 'Médio',
  'rating.bad': 'Ruim',

  // Página de Autenticação
  'auth.branding.headline1': 'Nem toda ideia é boa.',
  'auth.branding.headline2': 'Nós dizemos honestamente.',
  'auth.branding.subtitle':
    'Uma IA de decisão para nichos de negócios. Clara. Crítica. Sem açúcar.',
  'auth.benefits.privacy.title': '100% Privado',
  'auth.benefits.privacy.desc':
    'Suas ideias permanecem completamente privadas e seguras.',
  'auth.benefits.honest.title': 'IA Honesta',
  'auth.benefits.honest.desc':
    'Sem açúcar – apenas feedback claro e crítico.',
  'auth.benefits.fast.title': 'Resultados Rápidos',
  'auth.benefits.fast.desc': 'Obtenha clareza sobre seu nicho em minutos.',
  'auth.trust.users': 'Usuários Ativos',
  'auth.trust.ideas': 'Ideias Analisadas',
  'auth.trust.rating': 'Avaliação dos Usuários',
  'auth.login.title': 'Entrar',
  'auth.login.headline': 'Bem-vindo de volta',
  'auth.login.subtitle': 'Faça login para continuar sua jornada.',
  'auth.login.forgotPassword': 'Esqueceu a senha?',
  'auth.login.submit': 'Entrar',
  'auth.login.noAccount': 'Ainda não tem conta?',
  'auth.login.signUp': 'Cadastre-se',
  'auth.register.title': 'Registrar',
  'auth.register.headline': 'Crie sua conta',
  'auth.register.subtitle':
    'Comece a analisar suas ideias de negócio hoje.',
  'auth.register.submit': 'Criar Conta',
  'auth.register.hasAccount': 'Já tem uma conta?',
  'auth.register.signIn': 'Entrar',
  'auth.fields.name': 'Nome Completo',
  'auth.fields.email': 'Endereço de Email',
  'auth.fields.password': 'Senha',
  'auth.fields.confirmPassword': 'Confirmar Senha',
  'auth.fields.selectPlan': 'Selecione seu plano',
  'auth.fields.testCode': 'Entrar e testar gratuitamente',
  'auth.placeholders.name': 'Digite seu nome',
  'auth.placeholders.email': 'Digite seu email',
  'auth.placeholders.password': 'Digite sua senha',
  'auth.placeholders.confirmPassword': 'Confirme sua senha',
  'auth.placeholders.testCode': 'Digite o código de teste',
  'auth.terms.accept': 'Eu aceito os',
  'auth.terms.terms': 'Termos e Condições',
  'auth.privacy.accept': 'Eu aceito a',
  'auth.privacy.policy': 'Política de Privacidade',
  'auth.errors.nameRequired': 'O nome é obrigatório',
  'auth.errors.emailRequired': 'O email é obrigatório',
  'auth.errors.emailInvalid': 'Por favor, insira um email válido',
  'auth.errors.passwordRequired': 'A senha é obrigatória',
  'auth.errors.passwordLength': 'A senha deve ter pelo menos 8 caracteres',
  'auth.errors.passwordMismatch': 'As senhas não coincidem',
  'auth.errors.invalidCode': 'Código inválido ou expirado',
  'auth.errors.registrationCodeOnly': 'Este código é apenas para registro',
  'auth.errors.verificationFailed': 'Erro ao verificar o código. Tente novamente.',
  'auth.loading': 'Aguarde...',
  'auth.or': 'ou continue com',
  'auth.social.google': 'Continuar com Google',
  'auth.social.apple': 'Continuar com Apple',
  'auth.actions.verify': 'Verificar',
  'auth.testCode.activated': 'Código de teste ativado!',
  'auth.testCode.days': 'dias',
  'auth.testCode.months': 'meses',
  'auth.testCode.freeAccess': 'acesso gratuito',
  'auth.testCode.credits': 'créditos',

  // Verificação de Email
  'auth.verification.title': 'Verificar Email',
  'auth.verification.headline': 'Verifique sua caixa de entrada',
  'auth.verification.subtitle': 'Enviamos um código de verificação para:',
  'auth.verification.codeLabel': 'Código de Verificação',
  'auth.verification.codePlaceholder': 'Digite o código de 6 dígitos',
  'auth.verification.submit': 'Verificar Email',
  'auth.verification.resend': 'Reenviar código',
  'auth.verification.resendIn': 'Reenviar em',
  'auth.verification.seconds': 'segundos',
  'auth.verification.success': 'Email verificado com sucesso!',
  'auth.verification.error': 'Código inválido. Tente novamente.',
  'auth.verification.expired': 'Código expirado. Solicite um novo.',
  'auth.verification.sent': 'Novo código enviado!',
  'auth.verification.checkSpam':
    'Não recebeu? Verifique sua pasta de spam.',

  // Esqueci a Senha
  'auth.forgot.title': 'Esqueci a Senha',
  'auth.forgot.headline': 'Redefinir sua senha',
  'auth.forgot.subtitle':
    'Digite seu endereço de email e enviaremos um link de redefinição.',
  'auth.forgot.submit': 'Enviar Link de Redefinição',
  'auth.forgot.backToLogin': 'Voltar ao login',
  'auth.forgot.success': 'Email enviado!',
  'auth.forgot.successMessage':
    'Enviamos um email com instruções para redefinir sua senha.',
  'auth.forgot.checkInbox': 'Verifique sua caixa de entrada',

  // Redefinir Senha
  'auth.reset.title': 'Nova Senha',
  'auth.reset.headline': 'Definir nova senha',
  'auth.reset.subtitle': 'Digite sua nova senha.',
  'auth.reset.newPassword': 'Nova Senha',
  'auth.reset.confirmNewPassword': 'Confirmar Nova Senha',
  'auth.reset.submit': 'Alterar Senha',
  'auth.reset.success': 'Senha alterada com sucesso!',
  'auth.reset.successMessage':
    'Agora você pode entrar com sua nova senha.',
  'auth.reset.loginNow': 'Entrar agora',

  // Páginas Legais
  'legal.backToAuth': 'Voltar ao login',
  'legal.allRightsReserved': 'Todos os direitos reservados.',

  // Página de Termos
  'legal.terms.title': 'Termos e Condições',
  'legal.terms.lastUpdated': 'Última atualização',
  'legal.terms.section1.title': '1. Escopo',
  'legal.terms.section1.content':
    'Estes Termos e Condições se aplicam a todos os contratos entre a NicheFinder (doravante "Provedor") e o usuário (doravante "Cliente") relativos ao uso da plataforma de análise de nichos baseada em IA.',
  'legal.terms.section2.title': '2. Descrição do Serviço',
  'legal.terms.section2.content':
    'O Provedor oferece uma plataforma baseada em IA que analisa e avalia ideias e nichos de negócios. Os serviços incluem:',
  'legal.terms.section2.item1': 'Análise de ideias de negócios baseada em IA',
  'legal.terms.section2.item2': 'Avaliação do potencial de mercado e concorrência',
  'legal.terms.section2.item3': 'Geração de sugestões de nicho',
  'legal.terms.section2.item4': 'Criação de briefings para desenvolvedores (pacote Builder)',
  'legal.terms.section3.title': '3. Conclusão do Contrato e Registro',
  'legal.terms.section3.content':
    'O contrato é concluído através do registro na plataforma e seleção de um pacote. O cliente confirma:',
  'legal.terms.section3.item1': 'Ser maior de idade e plenamente capaz',
  'legal.terms.section3.item2': 'Fornecer informações verdadeiras durante o registro',
  'legal.terms.section3.item3': 'Armazenar as credenciais de acesso com segurança',
  'legal.terms.section4.title': '4. Créditos e Faturamento',
  'legal.terms.section4.content':
    'O uso das funcionalidades de IA é baseado em um sistema de créditos. Cada consulta à IA custa 30 créditos. Os créditos são debitados apenas mediante resposta bem-sucedida. Créditos não utilizados expiram no final do período de faturamento e não são reembolsados.',
  'legal.terms.section5.title': '5. Isenção de Responsabilidade',
  'legal.terms.section5.content':
    'As avaliações da IA servem apenas como auxílio à decisão e não garantem sucesso nos negócios. O Provedor não é responsável por decisões tomadas com base nas análises da IA. A responsabilidade por dolo e negligência grave permanece inalterada.',
  'legal.terms.section6.title': '6. Proteção de Dados e Confidencialidade',
  'legal.terms.section6.content':
    'Todas as ideias de negócio submetidas são tratadas confidencialmente e não são compartilhadas com terceiros. O processamento de dados pessoais é realizado de acordo com nossa Política de Privacidade e leis de proteção de dados aplicáveis.',
  'legal.terms.section7.title': '7. Rescisão',
  'legal.terms.section7.content':
    'O cliente pode cancelar sua assinatura a qualquer momento no final do período de faturamento atual. Em caso de violação destes Termos, o Provedor reserva-se o direito de bloquear o acesso à plataforma.',
  'legal.terms.section8.title': '8. Disposições Finais',
  'legal.terms.section8.content':
    'A lei suíça se aplica. O foro é Zurique, Suíça. Se disposições individuais destes Termos forem inválidas, a validade das disposições restantes permanece inalterada.',
  'legal.terms.contact.title': 'Dúvidas sobre os Termos?',
  'legal.terms.contact.content':
    'Se você tiver dúvidas sobre estes Termos e Condições, entre em contato conosco em:',

  // Página de Privacidade
  'legal.privacy.title': 'Política de Privacidade',
  'legal.privacy.section1.title': '1. Controlador de Dados',
  'legal.privacy.section1.content':
    'O controlador de dados deste site é a NicheFinder, Zurique, Suíça. Levamos a proteção dos seus dados pessoais muito a sério e tratamos seus dados pessoais de forma confidencial e de acordo com os regulamentos legais de proteção de dados.',
  'legal.privacy.section2.title': '2. Dados Coletados',
  'legal.privacy.section2.content':
    'Coletamos e processamos os seguintes dados pessoais:',
  'legal.privacy.section2.item1':
    'Dados de registro: Nome, endereço de email, senha (criptografada)',
  'legal.privacy.section2.item2':
    'Dados de uso: Endereço IP, tipo de navegador, horários de acesso',
  'legal.privacy.section2.item3':
    'Ideias de negócio e consultas de nicho (armazenadas anonimamente)',
  'legal.privacy.section2.item4':
    'Informações de pagamento (via provedores terceiros seguros)',
  'legal.privacy.section3.title': '3. Finalidade do Processamento de Dados',
  'legal.privacy.section3.content':
    'Seus dados são usados para os seguintes fins:',
  'legal.privacy.section3.item1':
    'Fornecimento e melhoria dos nossos serviços de IA',
  'legal.privacy.section3.item2':
    'Gerenciamento de conta e autenticação',
  'legal.privacy.section3.item3':
    'Faturamento e processamento de pagamentos',
  'legal.privacy.section4.title': '4. Segurança dos Dados',
  'legal.privacy.section4.content':
    'Implementamos medidas de segurança técnicas e organizacionais para proteger seus dados contra manipulação, perda, destruição ou acesso não autorizado. Todas as transferências de dados são criptografadas via SSL/TLS.',
  'legal.privacy.section5.title': '5. Confidencialidade das Suas Ideias de Negócio',
  'legal.privacy.section5.content':
    'Suas ideias de negócio e consultas de nicho submetidas são tratadas com estrita confidencialidade. Não são compartilhadas com terceiros, não são usadas para fins de treinamento e podem ser completamente excluídas mediante solicitação. Suas ideias pertencem a você.',
  'legal.privacy.section6.title': '6. Seus Direitos',
  'legal.privacy.section6.content':
    'Você tem os seguintes direitos em relação aos seus dados pessoais:',
  'legal.privacy.section6.item1': 'Direito de acessar os dados armazenados',
  'legal.privacy.section6.item2': 'Direito de retificar dados imprecisos',
  'legal.privacy.section6.item3': 'Direito de excluir seus dados',
  'legal.privacy.section6.item4': 'Direito à portabilidade dos dados',
  'legal.privacy.section7.title': '7. Cookies',
  'legal.privacy.section7.content':
    'Nosso site usa apenas cookies tecnicamente necessários para autenticação e gerenciamento de sessão. Não usamos cookies de rastreamento ou ferramentas de análise de terceiros sem seu consentimento explícito.',
  'legal.privacy.section8.title': '8. Alterações nesta Política de Privacidade',
  'legal.privacy.section8.content':
    'Reservamo-nos o direito de adaptar esta política de privacidade para cumprir com requisitos legais alterados ou quando houver mudanças no serviço. A versão atual pode sempre ser encontrada nesta página.',
  'legal.privacy.contact.title': 'Dúvidas sobre Privacidade?',
  'legal.privacy.contact.content':
    'Se você tiver dúvidas sobre o processamento dos seus dados pessoais, entre em contato conosco em:',

  'auth.passwordStrength.label': 'Força da senha',
  'auth.passwordStrength.weak': 'Fraca',
  'auth.passwordStrength.medium': 'Média',
  'auth.passwordStrength.strong': 'Forte',
  'auth.passwordStrength.veryStrong': 'Muito forte',
  'auth.passwordStrength.minLength': 'Mín. 8 caracteres',
  'auth.passwordStrength.uppercase': 'Letra maiúscula',
  'auth.passwordStrength.number': 'Número',
  'auth.passwordStrength.special': 'Caractere especial',

  trial: {
    subtitle: 'Teste Gratuito',
    upgrade: 'Atualizar Agora',
    creditsRemaining: 'créditos restantes',
    inputHint: 'Versão de teste - Histórico de conversas não disponível',
    banner: {
      title: 'Teste de 7 Dias Ativo',
      remaining: '{{days}} dias restantes',
      credits: 'créditos disponíveis',
      upgradeNow: 'Atualizar Agora',
    },
    welcome: {
      title: 'Bem-vindo ao Teste Gratuito!',
      desc: 'Teste nosso assistente IA gratuitamente por 7 dias com 100 créditos. Faça perguntas e descubra as possibilidades!',
    },
    info: {
      title: 'Limitações do Teste',
      credits: '100 créditos por 7 dias',
      noHistory: 'Sem histórico de conversas',
      noSettings: 'Funcionalidades limitadas',
      upgrade: 'Atualize para funcionalidades completas',
    },
  },

  // ─── Página de Configurações ─────────────────────────────────────────────────
  'settings.title': 'Configurações',
  'settings.subtitle': 'Gerencie sua conta e preferências',
  'settings.backToOverview': 'Voltar à visão geral',
  'settings.subscriptionLink': 'Assinatura e Faturamento',
  'settings.saved': 'Alterações salvas com sucesso',
  'settings.changesSaved': 'Alterações salvas',
  'settings.saveChanges': 'Salvar alterações',
  'settings.dataExported': 'Dados exportados com sucesso',

  // Abas
  'settings.tabs.profile': 'Perfil',
  'settings.tabs.preferences': 'Preferências',
  'settings.tabs.notifications': 'Notificações',
  'settings.tabs.account': 'Conta e Plano',

  // Perfil
  'settings.profile.changePhoto': 'Alterar foto',
  'settings.profile.photoHint': 'JPG, PNG ou GIF (máx. 2MB)',
  'settings.profile.uploading': 'Enviando...',
  'settings.profile.photoUpdated': 'Foto do perfil atualizada!',
  'settings.profile.name': 'Nome',
  'settings.profile.email': 'Email',
  'settings.profile.phone': 'Telefone',
  'settings.profile.changePassword': 'Alterar senha',
  'settings.profile.currentPassword': 'Senha atual',
  'settings.profile.newPassword': 'Nova senha',
  'settings.profile.confirmPassword': 'Confirmar senha',

  // Preferências
  'settings.preferences.language': 'Idioma',
  'settings.preferences.chooseLanguage': 'Escolher idioma',
  'settings.preferences.timezone': 'Fuso horário',
  'settings.preferences.currency': 'Moeda',

  // Notificações
  'settings.notifications.emailTitle': 'Notificações por Email',
  'settings.notifications.email.analysis': 'Análise concluída',
  'settings.notifications.email.analysisDesc': 'Receba um email quando sua análise estiver pronta',
  'settings.notifications.email.credits': 'Atualizações de créditos',
  'settings.notifications.email.creditsDesc': 'Notificações sobre créditos e reinicializações',
  'settings.notifications.email.billing': 'Faturas e Pagamentos',
  'settings.notifications.email.billingDesc': 'Notificações sobre faturas e alterações de plano',
  'settings.notifications.email.newsletter': 'Newsletter',
  'settings.notifications.email.newsletterDesc': 'Dicas, atualizações e novas funcionalidades',
  'settings.notifications.pushTitle': 'Notificações Push',
  'settings.notifications.push.analysis': 'Análise concluída',
  'settings.notifications.push.analysisDesc': 'Notificação no navegador quando a análise estiver pronta',
  'settings.notifications.push.credits': 'Alertas de créditos',
  'settings.notifications.push.creditsDesc': 'Alerta quando o saldo de créditos estiver baixo',

  // Conta
  'settings.account.currentSubscription': 'Assinatura Atual',
  'settings.account.plan': 'Plano',
  'settings.account.price': 'Preço',
  'settings.account.nextBilling': 'Próximo faturamento',
  'settings.account.manageSubscription': 'Gerenciar assinatura e pagamentos',
  'settings.account.dataPrivacy': 'Dados e Privacidade',
  'settings.account.exportData': 'Exportar dados',
  'settings.account.deleteAccount': 'Excluir conta',

  // Modal de Exclusão
  'settings.deleteModal.title': 'Excluir conta?',
  'settings.deleteModal.subtitle': 'Todos os dados serão permanentemente excluídos.',
  'settings.deleteModal.warning1': 'Todas as análises e dados serão excluídos',
  'settings.deleteModal.warning2': 'A assinatura ativa será cancelada imediatamente',
  'settings.deleteModal.warning3': 'Nenhum reembolso possível',
  'settings.deleteModal.confirmLabel': 'Digite "{{word}}" para confirmar *',
  'settings.deleteModal.cancel': 'Cancelar',
  'settings.deleteModal.confirm': 'Excluir conta',

  // ─── Assinatura e Faturamento ─────────────────────────────────────────────
  'sub.backToOverview': 'Voltar à visão geral',
  'sub.settings': 'Configurações',
  'sub.title': 'Assinatura e Faturamento',
  'sub.subtitle': 'Gerencie sua assinatura, métodos de pagamento e faturas',
  'sub.tab.overview': 'Visão Geral',
  'sub.tab.payment': 'Métodos de Pagamento',
  'sub.tab.billing': 'Endereço de Faturamento',
  'sub.tab.history': 'Histórico de Pagamentos',
  'sub.memberSince': 'Membro desde',
  'sub.perMonth': 'por mês',
  'sub.baseCHF': '(CHF {{amount}} base)',
  'sub.nextBilling': 'Próximo faturamento',
  'sub.creditsUsed': 'Créditos usados',
  'sub.paymentMethod': 'Método de pagamento',
  'sub.creditUsage': 'Uso de créditos',
  'sub.changePlan': 'Alterar plano',
  'sub.reactivate': 'Reativar',
  'sub.cancelSub': 'Cancelar assinatura',
  'sub.manageCards': 'Gerenciar cartões',
  'sub.downloadInvoices': 'Baixar faturas',
  'sub.invoicesAvailable': '{{count}} faturas disponíveis em PDF',
  'sub.accountSettings': 'Configurações da Conta',
  'sub.profileNotifications': 'Perfil, notificações e mais',
  // Preços em EUR
  'sub.eurInfo': 'Preços mostrados em',
  'sub.eurLabel': 'Euro',
  'sub.eurRate': 'Taxa:',
  'sub.currentRate': 'Taxa atual',
  // Métodos de Pagamento
  'sub.savedCards': 'Cartões Salvos',
  'sub.newCard': 'Novo Cartão',
  'sub.default': 'Padrão',
  'sub.setDefault': 'Definir como padrão',
  'sub.validUntil': 'Válido até',
  'sub.noCards': 'Nenhum cartão salvo',
  'sub.addFirstCard': 'Adicionar primeiro cartão',
  'sub.securePayments': 'Pagamentos Seguros',
  'sub.securePaymentsDesc': 'Todos os dados de pagamento são transmitidos criptografados e armazenados com segurança com nosso provedor de pagamento. Não armazenamos números de cartão completos.',
  // Endereço de Faturamento
  'sub.billingAddress': 'Endereço de Faturamento',
  'sub.edit': 'Editar',
  'sub.name': 'Nome',
  'sub.streetAddress': 'Rua e Número',
  'sub.zip': 'CEP',
  'sub.city': 'Cidade',
  'sub.country': 'País',
  'sub.address': 'Endereço',
  'sub.save': 'Salvar',
  'sub.cancel': 'Cancelar',
  'sub.country.switzerland': 'Suíça',
  'sub.country.germany': 'Alemanha',
  'sub.country.austria': 'Áustria',
  'sub.country.netherlands': 'Países Baixos',
  'sub.country.belgium': 'Bélgica',
  // Histórico de Pagamentos
  'sub.paymentHistory': 'Histórico de Pagamentos',
  'sub.allInvoicesPDF': 'Baixar todas as faturas como PDF com logo',
  'sub.downloadAll': 'Baixar todas',
  'sub.eurInvoiceNote': 'As faturas são sempre emitidas em CHF. Os valores em EUR exibidos são apenas para referência.',
  'sub.date': 'Data',
  'sub.description': 'Descrição',
  'sub.net': 'Líquido',
  'sub.vat': 'IVA',
  'sub.total': 'Total',
  'sub.status': 'Status',
  'sub.pdf': 'PDF',
  'sub.invoices': 'faturas',
  'sub.totalAmount': 'Valor total',
  // Modal de Alteração de Plano
  'sub.changePlanTitle': 'Alterar Plano',
  'sub.current': 'Atual',
  'sub.month': '/mês',
  'sub.showLess': 'Mostrar menos',
  'sub.showMore': '+{{count}} mais',
  'sub.switchPlan': 'Mudar para plano',
  'sub.eurPriceNote': 'Preços mostrados em EUR ({{note}}). O faturamento é em CHF.',
  // Modal de Cancelamento
  'sub.cancelTitle': 'Realmente cancelar assinatura?',
  'sub.cancelIrreversible': 'Esta ação não pode ser desfeita.',
  'sub.cancelWarning1': 'Todos os créditos restantes expirarão',
  'sub.cancelWarning2': 'Rebaixamento para o Plano Gratuito',
  'sub.cancelWarning3': 'Perda de todas as funcionalidades premium',
  'sub.pauseInstead': 'Alternativa: Pausar assinatura?',
  'sub.pauseDesc': 'Pause sua assinatura e mantenha seus dados.',
  'sub.preferPause': 'Preferir pausar',
  'sub.cancelReason': 'Motivo do cancelamento',
  'sub.selectReason': 'Por favor, selecione...',
  'sub.reason.tooExpensive': 'Muito caro',
  'sub.reason.notUsing': 'Não estou usando o suficiente',
  'sub.reason.missingFeatures': 'Funcionalidades faltando',
  'sub.reason.foundAlternative': 'Encontrei uma alternativa',
  'sub.reason.other': 'Outro',
  'sub.confirmType': 'Confirmação: Digite "CANCELAR" *',
  'sub.cancelNow': 'Cancelar agora',
  // Modal de Adicionar Cartão
  'sub.addCardTitle': 'Adicionar Novo Cartão',
  'sub.cardHolder': 'Titular do Cartão *',
  'sub.cardNumber': 'Número do Cartão *',
  'sub.expiryDate': 'Data de Validade *',
  'sub.addCard': 'Adicionar cartão',
  // Modal de Alterar Cartão
  'sub.choosePayment': 'Escolher método de pagamento',
  'sub.active': 'Ativo',
  'sub.close': 'Fechar',
  // Mensagens Toast
  'sub.toast.cancelled': 'Sua assinatura foi cancelada no final do período de faturamento.',
  'sub.toast.reactivated': 'Sua assinatura foi reativada com sucesso!',
  'sub.toast.planChanged': 'Plano alterado com sucesso para {{plan}}!',
  'sub.toast.defaultChanged': 'Método de pagamento padrão alterado.',
  'sub.toast.cannotDeleteDefault': 'O cartão padrão não pode ser excluído.',
  'sub.toast.cardRemoved': 'O cartão foi removido.',
  'sub.toast.fillAll': 'Por favor, preencha todos os campos.',
  'sub.toast.cardAdded': 'Novo cartão adicionado com sucesso!',
  'sub.toast.billingSaved': 'Endereço de faturamento salvo.',
  'sub.toast.invoiceDownloaded': 'Fatura {{id}} baixada!',
  'sub.toast.pdfError': 'Erro ao criar PDF.',
  // Interface do Chat
  'sub.notEnoughCredits': 'Créditos insuficientes',
  'sub.needCredits': 'Você precisa de pelo menos {{count}} créditos por pergunta.',
  'sub.creditsLow': 'Créditos acabando',
  'sub.questionsLeft': '{{count}} perguntas possíveis.',
  'sub.plan': 'Plano',
  'sub.base': 'base',
  'sub.unlimited': 'Ilimitado',
  'sub.status.active': 'Ativo',
  'sub.status.cancelled': 'Cancelado',
  'sub.status.paused': 'Pausado',
  'sub.invoice': 'FATURA',
  'sub.from': 'DE',
  'sub.to': 'PARA',
  'sub.vatId': 'NIF',
  'sub.tel': 'Tel',
  'sub.invoiceDate': 'Data da fatura',
  'sub.invoiceNumber': 'Número da fatura',
  'sub.paymentStatus': 'Status do pagamento',
  'sub.creditCard': 'Cartão de crédito',
  'sub.quantity': 'QTD',
  'sub.price': 'PREÇO',
  'sub.amount': 'VALOR',
  'sub.subtotal': 'Subtotal',
  'sub.bank': 'Banco',
  'sub.card': 'Cartão',
  'sub.cvc': 'CVC',
  'sub.cardHolderPlaceholder': 'João Silva',

  // ─── Painel do Administrador ─────────────────────────────────────────────────
  'admin.title': 'Painel do Administrador',
  'admin.subtitle': 'Central de Controle',
  'admin.superAdmin': 'Super Administrador',
  'admin.logout': 'Sair',
  'admin.tabs.users': 'Gerenciamento de Usuários',
  'admin.tabs.downgrades': 'Rebaixamentos',
  'admin.tabs.tips': 'Dica do Dia',
  'admin.tabs.coupons': 'Códigos de Cupom',
  'admin.tabs.website': 'Editor do Site',
  'admin.tabs.ai': 'Configurações da IA',
  'admin.tabs.transactions': 'Registro de Transações',
  'admin.tabs.stats': 'Estatísticas',
  'admin.users.searchPlaceholder': 'Pesquisar usuários (email ou nome)...',
  'admin.users.manageSubscription': 'Gerenciar assinatura',
  'admin.users.grantFree': 'Conceder conta gratuita',
  'admin.users.blockUser': 'Bloquear usuário',
  'admin.users.unblockUser': 'Desbloquear usuário',
  'admin.users.cancellationPlaceholder': 'Por que a assinatura está sendo cancelada?',
  'admin.users.selectPlan': 'Selecionar plano',
  'admin.users.subChanged': 'Assinatura de {{name}} alterada para {{plan}}',
  'admin.users.noReasonGiven': 'Nenhum motivo fornecido',
  'admin.users.subCancelled': 'Assinatura de {{name}} cancelada (válida até {{date}})',
  'admin.users.paused': 'Pausado',
  'admin.users.subPaused': 'Assinatura de {{name}} foi pausada',
  'admin.users.subReactivated': 'Assinatura de {{name}} foi reativada',
  'admin.users.freeAccount': 'Conta Gratuita',
  'admin.users.blocked': 'Bloqueado',
  'admin.users.cancelledExpiring': 'Cancelado (a expirar)',
  'admin.users.cancelledOn': 'Cancelado em:',
  'admin.users.endsOn': 'Termina em:',
  'admin.users.daysRemaining': 'dias restantes',
  'admin.users.expired': '(Expirado)',
  'admin.users.total': 'Total:',
  'admin.users.usersLabel': 'usuários',
  'admin.users.free': 'gratuito',
  'admin.users.block': 'Bloquear',
  'admin.users.unblock': 'Desbloquear',
  'admin.users.selectAction': 'Selecionar ação',
  'admin.users.cancelSub': 'Cancelar assinatura',
  'admin.users.cancelSubDesc': 'Cancelamento no final do mês',
  'admin.users.pauseSub': 'Pausar assinatura',
  'admin.users.pauseSubDesc': 'Pausa temporária',
  'admin.users.changePlan': 'Alterar plano',
  'admin.users.changePlanDesc': 'Mudar para outro plano',
  'admin.users.reactivateSub': 'Reativar assinatura',
  'admin.users.reactivateDesc': 'Desfazer cancelamento',
  'admin.users.alreadyCancelled': 'Assinatura já cancelada',
  'admin.users.planLabel': 'Plano',
  'admin.users.cancellationReasonOpt': 'Motivo do cancelamento (opcional)',
  'admin.users.cancelInfo1': 'A assinatura terminará em',
  'admin.users.cancelInfo2': '(final do mês). Até lá, o usuário tem acesso completo. Sem reembolso.',
  'admin.users.newPlan': 'Novo plano',
  'admin.users.warning': 'Aviso',
  'admin.users.blockDesc': 'O usuário será imediatamente desconectado e não poderá fazer login novamente. Todas as sessões ativas serão encerradas.',
  'admin.users.confirmUnblock': 'Confirmar desbloqueio',
  'admin.users.unblockDesc': 'O usuário pode fazer login novamente e usar todas as funcionalidades.',
  'admin.users.afterBlock': 'Após o bloqueio:',
  'admin.users.afterUnblock': 'Após o desbloqueio:',
  'admin.users.noAccountAccess': 'Sem acesso à conta',
  'admin.users.noNewAnalyses': 'Sem novas análises possíveis',
  'admin.users.creditsStored': 'Créditos e histórico permanecem armazenados',
  'admin.users.accessRestored': 'Acesso à conta restaurado',
  'admin.users.allFeaturesAvail': 'Todas as funcionalidades disponíveis novamente',
  'admin.users.creditsPreserved': 'Créditos e histórico preservados',
  'admin.users.downgrade': 'Rebaixar Plano',
  'admin.users.grantFreeBtn': 'Conceder gratuito',
  'admin.users.durationMonths': 'Duração (meses)',
  'admin.users.months': 'mês(es)',
  'admin.users.freePlan': 'gratuito',
  'admin.users.freeSummary': 'recebe',
  'admin.users.withCredits': 'com',
  'admin.users.credits': 'Créditos',
  'admin.users.subInfo': 'Informações da Assinatura',
  'admin.users.currentPlan': 'Plano Atual',
  'admin.users.joined': 'Registrado em',
  'admin.users.totalSpent': 'Total Gasto',
  'admin.users.paymentMethod': 'Método de Pagamento',
  'admin.users.validThrough': 'Válido até',
  'admin.users.billingAddress': 'Endereço de Faturamento',
  'admin.users.transactionHistory': 'Histórico de Transações',
  'admin.users.cancellationDate': 'Data de cancelamento',
  'admin.users.validUntil': 'Válido até (final do mês)',
  'admin.users.cancellationReason': 'Motivo do cancelamento',
  'admin.users.noReason': 'Nenhum motivo fornecido',
  'admin.users.timeRemaining': 'Tempo restante',
  'admin.users.daysUntilDeactivation': 'dias até a desativação',
  'admin.table.user': 'Usuário',
  'admin.table.plan': 'Plano',
  'admin.table.subStatus': 'Status da Assinatura',
  'admin.table.cancellation': 'Cancelamento',
  'admin.table.payment': 'Método de Pagamento',
  'admin.table.spending': 'Gastos',
  'admin.table.actions': 'Ações',
  'admin.actions.viewDetails': 'Ver detalhes',
  'admin.actions.manageSubscription': 'Gerenciar assinatura',
  'admin.actions.grantFree': 'Conceder acesso gratuito',
  'admin.actions.block': 'Bloquear usuário',
  'admin.actions.unblock': 'Desbloquear usuário',
  'admin.actions.cancel': 'Cancelar',
  'admin.actions.save': 'Salvar',
  'admin.actions.delete': 'Excluir',
  'admin.actions.confirm': 'Confirmar',
  'admin.actions.done': 'Concluído',
  'admin.actions.edit': 'Editar',
  'admin.actions.close': 'Fechar',
  'admin.table.status': 'Status',
  'admin.filter.all': 'Todos',
  'admin.subscription.active': 'Ativo',
  'admin.subscription.cancelled': 'Cancelado',
  'admin.subscription.paused': 'Pausado',
  'admin.subscription.unknown': 'Desconhecido',
  'admin.status.active': 'Ativo',
  'admin.status.inactive': 'Inativo',
  'admin.status.pending': 'Pendente',
  'admin.status.approved': 'Aprovado',
  'admin.status.rejected': 'Rejeitado',
  'admin.coupons.title': 'Gerenciamento de Cupons',
  'admin.coupons.subtitle': 'Criar e gerenciar códigos de cupom',
  'admin.coupons.newCoupon': 'Novo Cupom',
  'admin.coupons.registrationCoupons': 'Cupons de Registro',
  'admin.coupons.trialCoupons': 'Cupons de Acesso de Teste',
  'admin.coupons.type': 'Tipo',
  'admin.coupons.plan': 'Plano',
  'admin.coupons.value': 'Valor',
  'admin.coupons.usage': 'Uso',
  'admin.coupons.validUntil': 'Válido Até',
  'admin.coupons.created': 'Criado',
  'admin.coupons.actions': 'Ações',
  'admin.coupons.copyCode': 'Copiar código',
  'admin.coupons.allPlans': 'Todos os Planos',
  'admin.coupons.discount': 'Desconto',
  'admin.coupons.days': 'dias',
  'admin.coupons.months': 'meses',
  'admin.coupons.free': 'gratuito',
  'admin.coupons.unlimited': 'Ilimitado',
  'admin.coupons.createRegistration': 'Criar Cupom de Registro',
  'admin.coupons.createTrial': 'Criar Cupom de Acesso de Teste',
  'admin.coupons.couponCode': 'Código do Cupom',
  'admin.coupons.codePlaceholder': 'ex: NF-7X3K9M',
  'admin.coupons.generateCode': 'Gerar novo código',
  'admin.coupons.alertFillRequired': 'Por favor, preencha todos os campos obrigatórios',
  'admin.coupons.alertSelectExpiry': 'Por favor, selecione uma data de validade ou ative "Validade ilimitada"',
  'admin.coupons.alertCreateError': 'Erro ao criar cupom',
  'admin.coupons.confirmDelete': 'Tem certeza que deseja excluir este cupom?',
  'admin.coupons.discountPercent': 'Desconto (%)',
  'admin.coupons.bonusCredits': 'Créditos Bônus',
  'admin.coupons.freeDuration': 'Duração Gratuita',
  'admin.coupons.maxUses': 'Usos Máximos',
  'admin.coupons.expiryDate': 'Data de Validade',
  'admin.coupons.unlimitedValidity': 'Validade ilimitada',
  'admin.coupons.unlimitedUses': 'Usos ilimitados',
  'admin.coupons.trialCredits': 'Créditos de Teste',
  'admin.coupons.trialDuration': 'Duração do Teste',
  'admin.coupons.typePlaceholder': 'ex: Early Bird, Parceiro, Influenciador',
  'admin.coupons.duration': 'Duração',
  'admin.stats.totalUsers': 'Total de Usuários',
  'admin.stats.monthlyRevenue': 'Receita Mensal',
  'admin.stats.activeSubscriptions': 'Assinaturas Ativas',
  'admin.stats.average': 'Média',
  'admin.stats.revenuePerUser': 'Receita por Usuário',
  'admin.stats.grossRevenue': 'Receita Bruta',
  'admin.stats.net': 'LÍQUIDO',
  'admin.stats.netRevenue': 'Receita Líquida',
  'admin.stats.churnRate': 'Taxa de Churn',
  'admin.stats.planDistribution': 'Distribuição de Planos',
  'admin.stats.users': 'usuários',
  'admin.stats.revenueByPlan': 'Receita por Plano',
  'admin.stats.recentActivity': 'Atividade Recente',
  'admin.stats.activity1': 'Thomas Weber atualizou para Builder',
  'admin.stats.activity2': 'Novo usuário registrado',
  'admin.stats.activity3': 'Anna Schmidt atualizou para Pro',
  'admin.stats.hoursAgo2': 'há 2 horas',
  'admin.stats.hoursAgo5': 'há 5 horas',
  'admin.stats.dayAgo1': 'há 1 dia',
  'admin.stats.couponStats': 'Estatísticas de Cupons',
  'admin.stats.totalRedemptions': 'Total de Resgates',
  'admin.stats.activeCoupons': 'Cupons Ativos',
  'admin.stats.registrationRedemptions': 'Resgates de Registro',
  'admin.stats.trialRedemptions': 'Resgates de Teste',
  'admin.stats.couponDistribution': 'Distribuição de Cupons',
  'admin.stats.registrationCoupons': 'Cupons de Registro',
  'admin.stats.trialCoupons': 'Cupons de Teste',
  'admin.stats.expiredInactive': 'Expirados/Inativos',
  'admin.stats.topCoupons': 'Principais Cupons por Resgates',
  'admin.stats.redemptions': 'resgates',
  'admin.stats.noCouponsRedeemed': 'Nenhum cupom resgatado ainda',
  'admin.downgrade.pending': 'pendente',
  'admin.downgrade.refunds': 'Reembolsos',
  'admin.downgrade.sectionRequests': 'Solicitações',
  'admin.downgrade.sectionStats': 'Estatísticas',
  'admin.downgrade.sectionRules': 'Regras',
  'admin.downgrade.pendingRequests': 'Solicitações Pendentes',
  'admin.downgrade.approvedRequests': 'Solicitações Aprovadas',
  'admin.downgrade.rejectedRequests': 'Solicitações Rejeitadas',
  'admin.downgrade.activeRules': 'Regras Ativas',
  'admin.downgrade.autoRules': 'Regras de Rebaixamento Automático',
  'admin.downgrade.autoRulesDesc': 'Crie regras que acionam automaticamente rebaixamentos com base no comportamento de uso',
  'admin.downgrade.newRule': 'Nova Regra',
  'admin.downgrade.totalRules': 'Total de Regras',
  'admin.downgrade.triggeredActions': 'Ações Acionadas',
  'admin.downgrade.conditionsAnd': 'Condições (AND vinculadas)',
  'admin.downgrade.action': 'Ação',
  'admin.downgrade.successTitle': 'Rebaixamento bem-sucedido!',
  'admin.downgrade.successDesc': 'O usuário foi rebaixado com sucesso e o reembolso foi processado.',
  'admin.downgrade.closing': 'Fechando...',
  'admin.downgrade.title': 'Rebaixar Usuário',
  'admin.downgrade.currentPlan': 'Plano Atual',
  'admin.downgrade.spending': 'Gastos',
  'admin.downgrade.availablePlans': 'Planos Disponíveis para Rebaixamento',
  'admin.downgrade.perMonth': 'por mês',
  'admin.downgrade.refundCalc': 'Cálculo do Reembolso',
  'admin.downgrade.currentPlanLabel': 'Plano Atual',
  'admin.downgrade.newPlan': 'Novo Plano',
  'admin.downgrade.remainingDays': 'Dias Restantes',
  'admin.downgrade.daysOf': '15 de 30 dias',
  'admin.downgrade.proRataRefund': 'Reembolso Proporcional',
  'admin.downgrade.importantNote': 'Nota Importante',
  'admin.downgrade.warningDesc': 'O rebaixamento será executado imediatamente. O usuário perderá o acesso às funcionalidades premium e os créditos excedentes serão removidos.',
  'admin.downgrade.processing': 'Processando...',
  'admin.downgrade.execute': 'Executar Rebaixamento',
  'admin.downgrade.notification': 'Notificação',
  'admin.downgrade.noNotification': 'Sem Notificação',
  'admin.downgrade.daysPeriod': 'dias de carência',
  'admin.downgrade.created': 'Criado:',
  'admin.downgrade.triggered': 'acionado',
  'admin.downgrade.noRules': 'Nenhuma regra criada ainda',
  'admin.downgrade.createFirstRule': 'Criar primeira regra',
  'admin.downgrade.editRule': 'Editar Regra',
  'admin.downgrade.createRule': 'Criar Nova Regra',
  'admin.downgrade.ruleName': 'Nome da regra',
  'admin.downgrade.description': 'Descrição',
  'admin.downgrade.allConditions': 'Condições (todas devem ser atendidas)',
  'admin.downgrade.addCondition': 'Adicionar condição',
  'admin.downgrade.type': 'Tipo',
  'admin.downgrade.value': 'Valor',
  'admin.downgrade.fromPlan': 'Do plano',
  'admin.downgrade.toPlan': 'Para o plano',
  'admin.condition.inactivity': 'Inatividade',
  'admin.condition.creditUsage': 'Uso de Créditos',
  'admin.condition.loginFrequency': 'Frequência de Login',
  'admin.condition.featureUsage': 'Uso de Funcionalidades',
  'admin.condition.supportTickets': 'Tickets de Suporte',
  'admin.operator.lessThan': 'menor que',
  'admin.operator.greaterThan': 'maior que',
  'admin.operator.equals': 'exatamente',
  'admin.operator.between': 'entre',
  'admin.unit.days': 'dias',
  'admin.unit.perMonth': 'por mês',
  'admin.unit.count': 'contagem',
  'admin.transactions.all': 'Todas as Transações',
  'admin.transactions.allCards': 'Todos os Cartões',
  'admin.transactions.notFound': 'Nenhuma transação encontrada',
  'admin.transactions.totalLabel': 'Total',
  'admin.transactions.transactions': 'transações',
  'admin.tips.title': 'Dica do Dia',
  'admin.tips.subtitle': 'Criar e gerenciar dicas mostradas a todos os usuários',
  'admin.tips.active': 'Ativo',
  'admin.tips.currentlyShown': 'Esta dica está sendo mostrada a todos os usuários',
  'admin.tips.createNew': 'Criar Nova Dica',
  'admin.tips.generating': 'Gerando...',
  'admin.tips.generateAI': 'Gerar Dica com IA',
  'admin.tips.titleLabel': 'Título',
  'admin.tips.titlePlaceholder': 'ex: Dica do Dia',
  'admin.tips.category': 'Categoria',
  'admin.tips.categoryTip': 'Dica',
  'admin.tips.categoryFeature': 'Nova Funcionalidade',
  'admin.tips.categoryProductivity': 'Produtividade',
  'admin.tips.categoryUpdate': 'Atualização',
  'admin.tips.content': 'Conteúdo',
  'admin.tips.contentPlaceholder': 'Escreva sua dica para os usuários aqui...',
  'admin.tips.addTip': 'Adicionar Dica',
  'admin.tips.allTips': 'Todas as Dicas',
  'admin.tips.noTips': 'Nenhuma dica criada ainda',
  'admin.tips.noTipsHint': 'Clique em "Gerar Dica com IA" para começar',
  'admin.noData': 'Nenhum dado disponível',
  'admin.range.7d': '7 dias',
  'admin.range.30d': '30 dias',
  'admin.range.90d': '90 dias',
  'admin.range.1y': '1 ano',
  'admin.actions.saveSettings': 'Salvar configurações',
  'admin.actions.create': 'Criar',
  'admin.downgrade.sectionReports': 'Relatórios',
  'admin.downgrade.settings': 'Configurações de Rebaixamento',
  'admin.downgrade.autoApprove': 'Aprovação Automática',
  'admin.downgrade.autoApproveDesc': 'Aprovar automaticamente solicitações de rebaixamento',
  'admin.downgrade.refundPolicy': 'Política de Reembolso',
  'admin.downgrade.prorata': 'Reembolso proporcional',
  'admin.downgrade.prorataDesc': 'Reembolso proporcional com base nos dias restantes',
  'admin.downgrade.fullRefund': 'Reembolso total',
  'admin.downgrade.fullRefundDesc': 'Reembolso completo da diferença de preço',
  'admin.downgrade.noRefund': 'Sem reembolso',
  'admin.downgrade.noRefundDesc': 'Rebaixamento sem reembolso',
  'admin.downgrade.daysRemaining15': '(com 15 dias restantes)',
  'admin.downgrade.requestsTitle': 'Solicitações de Rebaixamento',
  'admin.downgrade.approvalRate': 'Taxa de aprovação',
  'admin.downgrade.mostCommonTransition': 'Transição mais comum',
  'admin.downgrade.mostCommonReason': 'Motivo mais comum',
  'admin.downgrade.avgProcessingTime': 'Tempo médio de processamento',
  'admin.downgrade.avgTimeDesc': 'Tempo médio para decisão',
  'admin.downgrade.totalRefunds': 'Total de Reembolsos',
  'admin.downgrade.pendingRefunds': 'Reembolsos Pendentes',
  'admin.downgrade.summary': 'Resumo',
  'admin.downgrade.total': 'Total',
  'admin.downgrade.csvDesc': 'Para Excel, Google Sheets',
  'admin.downgrade.downloadCSV': 'Baixar como CSV',
  'admin.downgrade.jsonDesc': 'Para desenvolvedores, APIs',
  'admin.downgrade.downloadJSON': 'Baixar como JSON',
  'admin.downgrade.exportInfo': 'A exportação contém',
  'admin.downgrade.entries': 'entradas do período selecionado',
  'admin.downgrade.topReasons': 'Motivos mais comuns para rebaixamento',
  'admin.downgrade.refundHistory': 'Histórico de Reembolsos',
  'admin.downgrade.noRefunds': 'Nenhum reembolso ainda',
  'admin.downgrade.statistics': 'Estatísticas de Rebaixamento',
  'admin.downgrade.requests': 'Solicitações',
  'admin.downgrade.monthlyTrend': 'Tendência Mensal',
  'admin.downgrade.planTransitions': 'Transições de Plano',
  'admin.downgrade.trend': 'Tendência (vs. mês anterior)',
  'admin.downgrade.trendDesc': 'Menos rebaixamentos = melhor',
  'admin.coupons.allPlansUniversal': 'Todos os Planos (Universal)',
  'admin.coupons.onlyStarter': 'Apenas Starter',
  'admin.coupons.onlyPro': 'Apenas Pro',
  'admin.coupons.onlyBuilder': 'Apenas Builder',
  'admin.coupons.allPlansHint': 'Escolha "Todos os Planos" para um cupom universal',
  'admin.coupons.discountOptional': 'Desconto % (opcional)',
  'admin.coupons.discountPlaceholder': 'ex: 50 para 50% de desconto',
  'admin.coupons.bonusCreditsOptional': 'Créditos Bônus (opcional)',
  'admin.coupons.bonusCreditsPlaceholder': 'ex: 500',
  'admin.coupons.freeDurationOptional': 'Duração Gratuita (opcional)',
  'admin.coupons.durationPlaceholder': 'ex: 30',
  'admin.coupons.freeDurationHint': 'ex: 30 dias grátis para usar',
  'admin.coupons.noLimit': 'Sem limitação de uso',
  'admin.coupons.noExpiry': 'Sem data de validade',
  'admin.coupons.creditsPlaceholder': 'ex: 100',
  'admin.coupons.creditsHint': 'Número de créditos para o acesso de teste',
  'admin.coupons.trialDurationHint': 'Por quanto tempo o acesso de teste é válido',
  'admin.coupons.autoCalculated': 'Calculado automaticamente a partir da duração do teste',
  'admin.websiteEditor.title': 'Editor do Site',
  'admin.websiteEditor.subtitle': 'Editar todas as seções da página inicial',
  'admin.websiteEditor.openPreview': 'Abrir Pré-visualização',
  'admin.websiteEditor.group.structure': 'Estrutura da Página',
  'admin.websiteEditor.group.design': 'Design e Layout',
  'admin.websiteEditor.group.settings': 'Configurações',
  'admin.websiteEditor.tab.navbar': 'Navegação',
  'admin.websiteEditor.tab.howitworks': 'Como Funciona',
  'admin.websiteEditor.tab.about': 'Sobre Nós',
  'admin.websiteEditor.tab.pricing': 'Preços',
  'admin.websiteEditor.tab.sections': 'Seções',
  'admin.websiteEditor.tab.media': 'Mídia',
  'admin.websiteEditor.tab.chatwidget': 'Fale Conosco',
  'admin.websiteEditor.tab.invoice': 'Faturas',
  'admin.websiteEditor.tab.legal': 'Legal',
  'admin.websiteEditor.tab.seo': 'SEO Básico',
  'admin.websiteEditor.tab.advancedseo': 'SEO Avançado',
  'admin.websiteEditor.tab.versions': 'Versões',
  'admin.hero.title': 'Editar Seção Hero',
  'admin.hero.subtitle': 'Textos, botões e estatísticas da página inicial',
  'admin.hero.reset': 'Redefinir',
  'admin.hero.save': 'Salvar',
  'admin.hero.savedMsg': 'Dados do Hero salvos!',
  'admin.hero.badge': 'Texto do Selo',
  'admin.hero.headings': 'Títulos',
  'admin.hero.line1White': 'Linha 1 (branca)',
  'admin.hero.line2Gold': 'Linha 2 (dourada)',
  'admin.hero.subtitleSection': 'Subtítulo',
  'admin.hero.line1': 'Linha 1',
  'admin.hero.line2': 'Linha 2',
  'admin.hero.buttons': 'Botões',
  'admin.hero.primaryBtn': 'Botão Principal (dourado)',
  'admin.hero.secondaryBtn': 'Botão Secundário (borda)',
  'admin.hero.stats': 'Estatísticas',
  'admin.hero.statN': 'Estatística {{n}}',
  'admin.hero.value': 'Valor',
  'admin.hero.label': 'Rótulo',
  'admin.hero.previewNote': 'As alterações ficarão visíveis na página inicial após salvar. Recarregue a página para ver a pré-visualização.',

  // Histórico de Ideias
  'history.title': 'Histórico de Ideias',
  'history.countLabel': '{{count}} análises',
  'history.recentLabel': 'Suas análises recentes',
  'history.exportAll': 'Exportar tudo',
  'history.metrics.marketSize': 'Tamanho do Mercado',
  'history.metrics.competition': 'Concorrência',
  'history.metrics.startingCapital': 'Capital Inicial',
  'history.metrics.timeToMarket': 'Tempo para o Mercado',
  'history.metrics.profitPotential': 'Potencial de Lucro',
  'history.metrics.scalability': 'Escalabilidade',
  'history.summary.title': 'Resumo',
  'history.download': 'Baixar',
  'history.downloadJSON': 'Salvar como JSON',
  'history.downloadTXT': 'Salvar como TXT',
  'history.downloadPDF': 'Salvar como PDF',
  'history.fullAnalysis': 'Análise Completa',
  'history.searchPlaceholder': 'Pesquisar por título ou tags...',
  'history.filterAll': 'Todas as avaliações',
  'history.loading': 'Carregando análises...',
  'history.noResults': 'Nenhum resultado encontrado',
  'history.empty': 'Nenhuma análise ainda',
  'history.emptyHint': 'Inicie uma análise no Assistente IA',
  'history.delete': 'Excluir',
  'history.cancel': 'Cancelar',
  'history.deleteModalTitle': 'Excluir análise?',
  'history.deleteModalDesc': '"{{title}}" será permanentemente excluída.',
  'history.errorLoading': 'Erro ao carregar análises',
  'history.deleteSuccess': 'Análise excluída com sucesso',
  'history.deleteError': 'Erro ao excluir análise',
  'history.jsonExported': 'JSON exportado',
  'history.txtExported': 'TXT exportado',
  'history.allExported': '{{count}} ideias exportadas',
  'history.analysisHeader': 'ANÁLISE DE IDEIA',
  'history.titleLabel': 'Título',
  'history.ratingLabel': 'Avaliação',
  'history.dateLabel': 'Data',
  'history.creditsLabel': 'Créditos',
  'history.analysisSection': 'Análise',

  // Visão Geral
  'overview.title': 'Visão Geral',
  'overview.last24h': 'Últimas 24 horas',
  'overview.analysesToday': 'Análises hoje',
  'overview.totalAnalyses': 'Total de análises',
  'overview.successRate': 'Taxa de sucesso',
  'overview.topRatings': 'Principais avaliações',
  'overview.recentActivity': 'Atividade recente',
  'overview.viewAll': 'Ver todos',
  'overview.quickAccess': 'Acesso rápido',
  'overview.quick.newAnalysis': 'Iniciar nova análise',
  'overview.quick.newAnalysisDesc': 'Iniciar uma nova análise de nicho com IA',
  'overview.quick.myAnalyses': 'Minhas análises',
  'overview.quick.myAnalysesDesc': 'Ver todas as análises anteriores',
  'overview.quick.buyCredits': 'Comprar créditos',
  'overview.quick.buyCreditsDesc': 'Mais créditos para mais análises',
  'overview.quick.settings': 'Configurações',
  'overview.quick.settingsDesc': 'Personalizar perfil e preferências',
  'overview.unlimitedCredits': 'Créditos ilimitados disponíveis',
  'overview.creditsAvailable': 'créditos disponíveis',
  'overview.upgradePlan': 'Atualizar plano',
  'overview.buyCredits': 'Comprar créditos',
  'overview.creditUsage': 'Uso de créditos este mês',
  'overview.available': 'disponível',

  // --- Novas Chaves do Admin ---
  'admin.transactions.upgrades': 'Upgrades',
  'admin.transactions.downgrades': 'Downgrades',
  'admin.transactions.visa': 'Visa',
  'admin.transactions.mastercard': 'Mastercard',
  'admin.transactions.amex': 'Amex',

  'admin.users.grantFreeSuccess': '{{name}} agora tem {{months}} mês(es) do plano {{plan}} gratuito',
  'admin.users.blockSuccess': '{{name}} foi bloqueado',
  'admin.users.unblockSuccess': '{{name}} foi desbloqueado',
  'admin.users.removeFreeSuccess': 'O status gratuito de {{name}} foi removido',

  'admin.downgrade.plans.builder': 'Builder',
  'admin.downgrade.plans.pro': 'Pro',
  'admin.downgrade.plans.starter': 'Starter',
  'admin.downgrade.plans.free': 'Grátis',

  'admin.unit.percent': '%',

  'admin.tips.discoverNewFeature': 'Descubra Nova Funcionalidade',
  'admin.tips.productivityBoost': 'Aumento de Produtividade',
  'admin.tips.importantUpdate': 'Atualização Importante',
  'admin.tips.tipOfDay': 'Dica do Dia',

  'admin.actions.activate': 'Ativar',
  'admin.actions.deactivate': 'Desativar',
  'admin.websiteEditor.tab.features': 'Funcionalidades',
  'admin.websiteEditor.tab.testimonials': 'Depoimentos',
  'admin.websiteEditor.tab.faq': 'FAQ',
  'admin.websiteEditor.tab.cta': 'CTA',
  'admin.websiteEditor.tab.footer': 'Rodapé',
  'admin.websiteEditor.tab.design': 'Design',
  'admin.websiteEditor.tab.customcode': 'Código Personalizado',
  'admin.websiteEditor.tab.socials': 'Redes Sociais',
  'admin.websiteEditor.tab.importexport': 'Importar/Exportar',

  // --- Editor de Configurações da IA ---
  'admin.ai.title': 'Configurações do Assistente IA',
  'admin.ai.subtitle': 'Configurar comportamento, estilo e profundidade de análise',
  'admin.ai.smartWeightingActive': 'Ponderação Inteligente Ativa',
  'admin.ai.smartWeightingDesc': 'A IA combina automaticamente todas as perspectivas com ponderação inteligente. Com múltiplos presets, o primeiro é ponderado mais fortemente (preset primário). Você também pode ajustar a ponderação manualmente.',
  'admin.ai.modelTitle': 'Modelo de IA do IdeaVerdict',
  'admin.ai.modelSubtitle': 'Escolha o mecanismo de IA para todas as análises dos usuários',
  'admin.ai.activeModel': 'Modelo ativo:',
  'admin.ai.activeModelDesc': 'Todos os usuários recebem respostas deste modelo.',
  'admin.ai.recommendations': 'Recomendações para Resultados Ótimos',
  'admin.ai.new': 'NOVO',
  'admin.ai.recommendationsDesc': 'Combinações de presets comprovadas para a melhor qualidade de análise',
  'admin.ai.recommendationsInfo': 'Estas combinações foram testadas e entregam os melhores resultados. Clique em uma recomendação para aplicá-la diretamente.',
  'admin.ai.active': 'ATIVO',
  'admin.ai.apply': 'Aplicar',
  'admin.ai.avoid': 'Evitar',
  'admin.ai.excellentQuality': 'Qualidade Excelente',
  'admin.ai.goodQuality': 'Boa Qualidade',
  'admin.ai.poorQuality': 'Qualidade Diluída - Não Recomendado',
  'admin.ai.proTips': 'Dicas Pro',
  'admin.ai.tip1Title': '2 presets são ideais:',
  'admin.ai.tip1Desc': 'Perspectiva clara sem diluição',
  'admin.ai.tip2Title': 'O preset primário importa:',
  'admin.ai.tip2Desc': 'O primeiro preset tem a maior influência',
  'admin.ai.tip3Title': 'Evite opostos:',
  'admin.ai.tip3Desc': '"EXTREMO" + "Criativo" = contraditório',
  'admin.ai.tip4Title': 'Máximo de 3 presets:',
  'admin.ai.tip4Desc': 'Com 4+ presets o resultado torna-se muito geral',
  'admin.ai.warningManyPresets': 'Aviso: Muitos Presets',
  'admin.ai.warningManyPresetsDesc': 'Você tem {{count}} presets selecionados. Isso pode diluir o resultado.',
  'admin.ai.warningRecommend': 'Recomendado: Máximo 2-3 presets',
  'admin.ai.forOptimalResults': 'para resultados ótimos.',
  'admin.ai.presets': 'Presets',
  'admin.ai.multiSelect': '(seleção múltipla possível)',
  'admin.ai.presetsDesc': 'Escolha um ou mais presets. O primeiro preset é o preset primário com a maior ponderação.',
  'admin.ai.primaryPreset': 'Preset Primário',
  'admin.ai.weightControl': 'Controle de Peso',
  'admin.ai.weightControlDesc': 'Ajuste o quanto cada preset influencia a análise',
  'admin.ai.manual': 'Manual',
  'admin.ai.automatic': 'Automático',
  'admin.ai.autoWeightingActive': 'Ponderação automática ativa:',
  'admin.ai.autoWeightingDesc': 'A ponderação é otimizada automaticamente com base no número de presets.',
  'admin.ai.primary': 'PRIMÁRIO',
  'admin.ai.totalWeight': 'Total',
  'admin.ai.shouldBe100': 'deve ser 100%',
  'admin.ai.normalize': 'Normalizar',
  'admin.ai.combinedSettings': 'Configurações Combinadas',
  'admin.ai.presetsCount': 'presets',
  'admin.ai.strictness': 'Rigor',
  'admin.ai.realism': 'Realismo',
  'admin.ai.creativity': 'Criatividade',
  'admin.ai.detailLevel': 'Nível de Detalhe',
  'admin.ai.customInstructions': 'Instruções Personalizadas',
  'admin.ai.customInstructionsDesc': 'Instruções adicionais que são combinadas com os presets',
  'admin.ai.customInstructionsPlaceholder': 'ex: "Foco no mercado brasileiro", "Sempre use números concretos", "Compare com concorrentes existentes", "Sempre responda com exemplos"...',
  'admin.ai.customInstructionsHint': 'Estas instruções são automaticamente combinadas com os presets selecionados.',
  'admin.ai.manualFinetuning': 'Ajuste Fino Manual',
  'admin.ai.manualFinetuningHint': '(opcional, substitui os valores dos presets)',
  'admin.ai.manualFinetuningDesc': 'Ajuste manualmente os valores combinados se quiser refinar algo.',
  'admin.ai.tone': 'Tom',
  'admin.ai.mild': 'Suave',
  'admin.ai.strict': 'Rigoroso',
  'admin.ai.creative': 'Criativo',
  'admin.ai.realistic': 'Realista',
  'admin.ai.conservative': 'Conservador',
  'admin.ai.compact': 'Compacto',
  'admin.ai.detailed': 'Detalhado',
  'admin.ai.responseLength': 'Tamanho da Resposta',
  'admin.ai.short': 'Curto e Conciso',
  'admin.ai.medium': 'Médio',
  'admin.ai.long': 'Detalhado',
  'admin.ai.focusAreas': 'Áreas de Foco da Análise',
  'admin.ai.autoRating': 'Avaliação Automática',
  'admin.ai.autoRatingDesc': 'Toda análise recebe automaticamente uma avaliação (Bom/Médio/Ruim)',
  'admin.ai.showSources': 'Mostrar Fontes',
  'admin.ai.showSourcesDesc': 'Referências a fontes de dados e dados de mercado nas respostas',
  'admin.ai.hidePreview': 'Ocultar Pré-visualização',
  'admin.ai.showPreview': 'Mostrar Pré-visualização',
  'admin.ai.aiBehavior': 'Comportamento da IA',
  'admin.ai.length': 'Extensão',
  'admin.ai.liveExample': 'Exemplo ao Vivo',
  'admin.ai.testSettings': 'Testar suas configurações',
  'admin.ai.selectExampleQuestion': 'Selecionar pergunta de exemplo:',
  'admin.ai.userAsks': 'O usuário pergunta:',
  'admin.ai.generating': 'IA gerando resposta...',
  'admin.ai.generateExample': 'Gerar Resposta de Exemplo',
  'admin.ai.aiResponds': 'Assistente IA responde:',
  'admin.ai.generateHint': 'Clique em "Gerar Resposta de Exemplo" para ver como a IA responde com suas configurações.',
  'admin.ai.reset': 'Redefinir',
  'admin.ai.saved': 'Salvo!',
  'admin.ai.saveSettings': 'Salvar Configurações',

  // --- Cabeçalhos de Tabela ---
  'admin.coupons.code': 'Código',
  'admin.coupons.credits': 'Créditos',

  // --- Descrições dos Modelos de IA ---
  'admin.ai.model.standardDesc': 'Análise equilibrada com alta qualidade. A melhor escolha para a maioria das avaliações de nicho e validações de ideias.',
  'admin.ai.model.preciseAnalyses': 'Análises Precisas',
  'admin.ai.model.bestBalance': 'Melhor Equilíbrio',
  'admin.ai.model.recommended': 'Recomendado',
  'admin.ai.model.fastDesc': 'Respostas extremamente rápidas para verificações rápidas de nicho, brainstorming e avaliações iniciais. Ideal quando a velocidade é importante.',
  'admin.ai.model.fast': 'RÁPIDO',
  'admin.ai.model.fastestResponses': 'Respostas Mais Rápidas',
  'admin.ai.model.thinkingDesc': 'Análise profunda com pensamento lógico avançado. Para análises de mercado complexas, avaliações críticas e planejamento estratégico.',
  'admin.ai.model.deepestAnalysis': 'Análise Mais Profunda',
  'admin.ai.model.logicalThinking': 'Pensamento Lógico',
  'admin.ai.model.strategy': 'Estratégia',

  // --- Nomes e Descrições dos Presets da IA ---
  'admin.ai.preset.strict.name': 'Análise Rigorosa',
  'admin.ai.preset.strict.desc': 'Crítica, baseada em fatos, sem açúcar. Expõe fraquezas impiedosamente.',
  'admin.ai.preset.extreme.name': 'Análise EXTREMA',
  'admin.ai.preset.extreme.desc': 'Rigor máximo, crítica implacável, foco no pior cenário. Apenas para verificações de realidade difíceis.',
  'admin.ai.preset.professional.name': 'Profissional',
  'admin.ai.preset.professional.desc': 'Objetivo, estruturado, equilibrado. Como um consultor de negócios experiente.',
  'admin.ai.preset.realistic.name': 'Realista',
  'admin.ai.preset.realistic.desc': 'Honesto e prático. Foco na implementação viável e dados reais de mercado.',
  'admin.ai.preset.creative.name': 'Criativo e Motivador',
  'admin.ai.preset.creative.desc': 'Inspirador, rico em ideias, positivo. Encontra oportunidades e caminhos não convencionais.',
  'admin.ai.preset.balanced.name': 'Equilibrado',
  'admin.ai.preset.balanced.desc': 'Boa mistura de crítica e motivação. O modo padrão.',
  'admin.ai.preset.investor.name': 'Perspectiva do Investidor',
  'admin.ai.preset.investor.desc': 'Como um Capitalista de Risco. Foco em escalabilidade, ROI e estratégia de saída.',
  'admin.ai.preset.startup-coach.name': 'Coach de Startup',
  'admin.ai.preset.startup-coach.desc': 'Mentor prático para fundadores. Foco em implementação rápida e MVP.',
  'admin.ai.preset.market-researcher.name': 'Pesquisador de Mercado',
  'admin.ai.preset.market-researcher.desc': 'Baseado em dados e analítico. Análise profunda de mercado e concorrência.',
  'admin.ai.preset.risk-analyst.name': 'Analista de Risco',
  'admin.ai.preset.risk-analyst.desc': 'Foco em riscos e piores cenários. Para planejamento realista.',

  // --- Áreas de Foco ---
  'admin.ai.focus.marktanalyse': 'Análise de Mercado',
  'admin.ai.focus.wettbewerb': 'Concorrência',
  'admin.ai.focus.monetarisierung': 'Monetização',
  'admin.ai.focus.risiken': 'Riscos',
  'admin.ai.focus.finanzen': 'Finanças',
  'admin.ai.focus.skalierung': 'Escalabilidade',
  'admin.ai.focus.innovation': 'Inovação',
  'admin.ai.focus.trends': 'Tendências',
  'admin.ai.focus.differenzierung': 'Diferenciação',
  'admin.ai.focus.umsetzung': 'Implementação',
  'admin.ai.focus.zielgruppe': 'Público-Alvo',
  'admin.ai.focus.marketing': 'Marketing',

  // --- Opções de Tom ---
  'admin.ai.tone.direkt': 'Direto e Bruto',
  'admin.ai.tone.professionell': 'Profissional e Objetivo',
  'admin.ai.tone.ehrlich': 'Honesto e Prático',
  'admin.ai.tone.motivierend': 'Motivador e Positivo',
  'admin.ai.tone.freundlich': 'Amigável e Apoiador',
  'admin.ai.tone.akademisch': 'Acadêmico e Analítico',

  // --- Perguntas de Exemplo ---
  'admin.ai.question.niche': 'Qual nicho lucrativo você recomenda?',
  'admin.ai.question.evaluate': 'Avalie minha ideia: Um aplicativo para donos de cães',
  'admin.ai.question.trends': 'Quais tendências têm potencial atualmente?',
  'admin.ai.question.sharpen': 'Como posso aprimorar meu nicho?',

  'admin.ai.rec.bestCombination.title': '🏆 Melhor Combinação (2 Presets)',
  'admin.ai.rec.bestCombination.desc': 'Crítica mas construtiva, com passos de ação concretos',
  'admin.ai.rec.bestCombination.useCase': 'Recomendado para a maioria das análises',

  'admin.ai.rec.balancedThree.title': '⚖️ Equilibrado (3 Presets)',
  'admin.ai.rec.balancedThree.desc': 'Profissional, realista e amigável para investidores',
  'admin.ai.rec.balancedThree.useCase': 'Para análises de negócio abrangentes',

  'admin.ai.rec.creativeDriven.title': '💡 Criativo e Motivador (2 Presets)',
  'admin.ai.rec.creativeDriven.desc': 'Inspirador com dicas práticas de implementação',
  'admin.ai.rec.creativeDriven.useCase': 'Para ideação e brainstorming',

  'pdf.rating.good': 'Good',
  'pdf.rating.bad': 'Bad',
  'pdf.rating.medium': 'Medium',
  'pdf.header.subtitle': 'Analysis View',
  'pdf.footer.tagline': 'AI-Powered Niche Validation',
  'pdf.footer.page': 'Page',
  'pdf.benchmark.title': 'INDUSTRY BENCHMARK',
  'pdf.benchmark.yourScore': 'Your Score',
  'pdf.benchmark.top10': 'Top 10%: 85+',
  'pdf.marketAnalysis.title': 'MARKET ANALYSIS',
  'pdf.summary.title': 'SUMMARY',
  'pdf.structuredSummary.verdict': 'VERDICT',
  'pdf.disclaimer.body': 'This report was generated by an AI model and is intended for informational purposes only. It does not constitute financial, legal, tax, or investment advice. Market data, ratings, and projections are AI-generated estimates and may be incomplete or inaccurate. Please verify all information independently and consult qualified professionals before making any business or investment decisions. IdeaVerdict assumes no liability for actions taken based on this report.',
  'pdf.disclaimer.title': 'IMPORTANT NOTICE',
  'pdf.closing.title': 'Generated by IdeaVerdict',
  'pdf.closing.subtitle': 'AI-Powered Niche Validation  |  Comprehensive Market Intelligence',
  'history.swot.title': 'SWOT Analysis',
  'history.swot.strengths': 'Strengths',
  'history.swot.weaknesses': 'Weaknesses',
  'history.swot.opportunities': 'Opportunities',
  'history.swot.risks': 'Risks',
  'history.sections.recommendations': 'Recommendations',
  'history.sections.marketAnalysis': 'Competitive Analysis',
  'history.sections.microAngles': 'Micro-Niche Angles',
  'history.sections.improvements': 'Improvement Suggestions',
  'history.sections.alternatives': 'Alternative Niches',
  'history.sections.structuredSummary': 'Structured Summary (Builder)',
  'history.structuredSummary.strengths': 'Top Strengths',
  'history.structuredSummary.risks': 'Top Risks',
  'history.structuredSummary.actions': 'Next Steps',
  'history.sections.developerBriefing': 'Developer Briefing (Builder)',
  'history.sections.conversation': 'Conversation History',
  'history.conversation.user': 'User',
  'history.conversation.assistant': 'IdeaVerdict',
  'history.conversation.structuredResult': 'Structured Result',
  'admin.tabs.usage': 'Usage',
  'admin.usage.title': 'AI Usage & Cost Analysis',
  'admin.usage.refresh': 'Refresh data',
  'admin.usage.requests': 'Requests',
  'admin.usage.users': 'Users',
  'admin.usage.totalTokens': 'Total Tokens',
  'admin.usage.apiCosts': 'API Costs',
  'admin.usage.revenue': 'Revenue',
  'admin.usage.margin': 'Margin',
  'admin.usage.byModel': 'By Model',
  'admin.usage.allModels': 'All Models',
  'admin.usage.searchEmail': 'Search by email address...',
  'admin.usage.perPage': 'Per page:',
  'admin.usage.loading': 'Loading usage data...',
  'admin.usage.noEntries': 'No entries found for current filters.',
  'admin.usage.time': 'Time',
  'admin.usage.user': 'User',
  'admin.usage.model': 'Model',
  'admin.usage.credits': 'Credits',
  'admin.usage.tokens': 'Tokens',
  'admin.usage.duration': 'Duration',
  'admin.usage.details': 'Details',
  'admin.usage.showing': 'Showing',
  'admin.usage.of': 'of',
  'admin.usage.entries': 'entries',
  'admin.usage.firstPage': 'First Page',
  'admin.usage.prevPage': 'Previous',
  'admin.usage.page': 'Page',
  'admin.usage.nextPage': 'Next',
  'admin.usage.lastPage': 'Last Page',
  'admin.usage.requestDetails': 'Request Details',
  'admin.usage.close': 'Close',
  'admin.usage.loadingDetails': 'Loading details...',
  'admin.usage.inputTokens': 'Input Tokens',
  'admin.usage.outputTokens': 'Output Tokens',
  'admin.usage.providerCost': 'Provider Cost',
  'admin.usage.providerBreakdown': 'Provider Breakdown',
  'admin.usage.fullResponseData': 'Full Response Data',
  'admin.usage.entryNotFound': 'This entry could not be loaded.',
  'admin.usage.today': 'Today',
  'admin.usage.last7d': 'Last 7 Days',
  'admin.usage.last30d': 'Last 30 Days',
  'admin.usage.allTime': 'All Time',
  'admin.ai.fallbackModel': 'Fallback Model',
  'admin.ai.systemPrompts': 'System Prompts',
  'admin.ai.fallbackModelDesc': 'Used when the primary model fails or returns invalid output',
  'admin.ai.systemPromptsDesc': 'Read-only view of what each model receives as instructions',
  'admin.ai.provider': 'Provider',
  'admin.ai.modelId': 'Model ID',
  'admin.ai.maxTokens': 'Max Tokens',
  'admin.ai.temperature': 'Temperature',
  'admin.ai.thinkingBudget': 'Thinking Budget',
  'admin.ai.supportsThinking': 'Supports Thinking',
  'admin.ai.displayName': 'Display Name',
  'admin.ai.precise': 'Precise',
  'admin.ai.creativeTemp': 'Creative',

  // Header + Sidebar (auto-added by rebrand)
  'header.openMenu': 'Abrir menu',
  'header.home': 'Início',
  'header.notifications': 'Notificações',
  'header.settings': 'Configurações',
  'header.profile': 'Perfil',
  'sidebar.collapse': 'Recolher barra lateral',
  'sidebar.expand': 'Expandir barra lateral',
  'sidebar.close': 'Fechar menu',
  'sidebar.plan': 'Plano',
  'sidebar.backToWebsite': 'Voltar ao site',

  // Legal — Imprint (auto-added)
  'legal.imprint.title': 'Aviso legal',
  'legal.imprint.company': 'Scherbius Technology',
  'legal.imprint.location': 'Dubai, Emirados Árabes Unidos (EAU)',
  'legal.imprint.seatLabel': 'Sede registada',
  'legal.imprint.seatBody': 'Dubai, Emirados Árabes Unidos',
  'legal.imprint.contactLabel': 'Contato',
  'legal.imprint.contactBody': 'Os dados de contato são fornecidos a critério exclusivo da Scherbius Technology.',
  'legal.imprint.representationLabel': 'Representação legal',
  'legal.imprint.representationBody': 'A Scherbius Technology é representada pelos seus representantes legais conforme a legislação dos Emirados Árabes Unidos.',
  'legal.imprint.contentLiabilityLabel': 'Responsabilidade pelo conteúdo',
  'legal.imprint.contentLiabilityBody': 'Os conteúdos deste site foram elaborados com o maior cuidado possível.\nNo entanto, a Scherbius Technology não assume nenhuma responsabilidade pela exatidão, integridade ou atualidade dos conteúdos.',
  'legal.imprint.linksLiabilityLabel': 'Responsabilidade por links externos',
  'legal.imprint.linksLiabilityBody': 'Este site pode conter links para sites externos de terceiros sobre cujo conteúdo não temos qualquer influência.\nNão se assume qualquer responsabilidade por estes conteúdos externos.',
  'legal.imprint.lawLabel': 'Legislação aplicável',
  'legal.imprint.lawBody': 'Aplica-se exclusivamente a legislação dos Emirados Árabes Unidos.\nO foro competente é Dubai, EAU.',

  // Overview page (auto-added)
  'overview.greeting': 'Bem-vindo de volta',
  'overview.greetingSub': 'Aqui está o que está acontecendo na sua mesa de veredictos.',
  'overview.heroCta': 'Novo veredicto',
  'overview.currentPlan': 'Plano atual',
  'overview.creditsLabel': 'créditos',
  'overview.usedThisCycle': 'Usados neste ciclo',
  'overview.resetsOn': 'Renova em',
  'overview.unlimitedTitle': 'Ilimitado',
  'overview.builderPerk': 'Você tem acesso Builder completo — sem limites.',
  'overview.runOne': 'Executar um veredicto',
  'overview.lastVerdicts': 'Seus últimos 5 veredictos',
  'overview.noActivity': 'Sem veredictos ainda — inicie sua primeira análise',
  'overview.tipTitle': 'Dica',
  'overview.tipBody': 'Passe uma ideia por duas línguas — se o veredicto suaviza, suas suposições são locais, não universais.',
  'onboard.skip': "Pular",
  'onboard.cta.next': "Próximo",
  'onboard.cta.start': "Começar",
  'onboard.s1.title': "Bem-vindo ao IdeaVerdict",
  'onboard.s1.body': "Um veredicto de IA sobre sua ideia de negócio — antes de construí-la.",
  'onboard.s2.title': "Veredictos brutalmente honestos",
  'onboard.s2.body': "Sem hype, sem bajulação. Dados de mercado reais, concorrentes reais, riscos reais.",
  'onboard.s3.title': "Relatórios Builder em PDF",
  'onboard.s3.body': "Gere relatórios de 25 a 75 páginas com arquitetura completa, finanças e estratégia go-to-market.",
  'onboard.s4.title': "Pronto quando você estiver",
  'onboard.s4.body': "Cadastre-se e receba seu primeiro veredicto em menos de um minuto.",
  'builderReport.title': "Criando o seu Builder Report",
  'builderReport.subtitle': "Análise completa + briefing de desenvolvedor — baixado em PDF quando pronto.",
  'builderReport.idea': "A sua ideia",
  'builderReport.ideaPlaceholder': "Descreva a sua ideia de negócio…",
  'builderReport.cta': "Gerar relatório",
  'builderReport.credits': "créditos",
  'builderReport.deductedNow': "Debitado em caso de sucesso",
  'builderReport.dontClose': "Por favor não feche esta janela — a geração pode levar 30-90 segundos.",
  'builderReport.done': "PDF baixado — verifique sua pasta de downloads.",
  'builderReport.failed': "Falha na geração",
  'builderReport.close': "Fechar",
  'builderReport.cancel': "Cancelar",
  'builderReport.running': "Gerando…",
  'builderReport.retry': "Tentar novamente",
  'builderReport.unknownError': "Falha na geração. Seus créditos serão reembolsados.",
  'builderReport.signInRequired': "Você precisa estar conectado para gerar um relatório.",
  'builderReport.ideaRequired': "Descreva sua ideia para a IA ter algo para analisar.",
  'builderReport.fromChat': "Da sua conversa atual",
  'builderReport.noIdeaDetected': "Usaremos a ideia que estamos discutindo.",
  'builderReport.contextHint': "A IA usará tudo deste chat — nenhuma nova ideia será inventada.",
  'builderReport.step.core': "Gerando análise principal",
  'builderReport.step.market': "Adicionando análise de mercado estendida",
  'builderReport.step.tech': "Adicionando arquitetura técnica",
  'builderReport.step.financials': "Adicionando modelos financeiros",
  'builderReport.step.compet': "Adicionando inteligência competitiva",
  'builderReport.step.gtm': "Adicionando estratégia go-to-market",
  'builderReport.step.deepdive': "Adicionando análise setorial aprofundada",
  'builderReport.step.pdf': "Compilando o PDF…",
  'briefing.title': "Criando seu briefing de desenvolvedor",
  'briefing.subtitle': "Briefing técnico em 11 seções — baixado em PDF quando pronto.",
  'briefing.ideaPlaceholder': "Descreva sua ideia de negócio…",
  'briefing.cta': "Gerar briefing",
  'briefing.step.core': "Gerando briefing de desenvolvedor",
  'briefing.step.pdf': "Compilando o PDF…",
  'pricing.gold.name': "Gold",
  'pricing.gold.description': "Mais créditos + relatórios de 50 páginas",
  'pricing.gold.credits': "12.500 créditos por mês",
  'pricing.platinum.name': "Platinum",
  'pricing.platinum.description': "Nível máximo + relatórios de 75 páginas",
  'pricing.platinum.credits': "15.000 créditos por mês",

  // ─── Auto-backfilled from EN (2026-05-13) ───
  // These are English fallbacks for keys that hadn't been translated to
  // "pt" yet. Replace with native translations as needed.
  'nav.slogan': 'An AI verdict on your business idea — before you build',
  'chat.creditsPerQuestion': 'Credits/question',
  'chat.notEnoughCreditsTitle': 'Not enough credits',
  'chat.notEnoughCreditsDesc': 'You need at least {{cost}} credits per question.',
  'chat.creditsRunningLow': 'Credits running low',
  'chat.questionsRemaining': '{{count}} questions remaining.',
  'chat.noCreditsModalTitle': 'Not enough credits',
  'chat.noCreditsModalDesc': 'You need at least <1>{{cost}} credits</1> per question. Your current balance: <2>{{balance}} credits</2>',
  'chat.currentPlan': 'Current plan',
  'chat.close': 'Close',
  'chat.upgrade': 'Upgrade',
  'sub.manageBilling': 'Manage billing',
  'credits.topup.buyMore': 'Buy more credits',
  'trial.creditsLow': "Apenas {{count}} créditos restantes!",
  'trial.upgradeNow': "Atualizar agora",
  'trial.upgradeNowArrow': "Atualizar agora →",
  'trial.creditsExhausted': "Créditos esgotados",
  'trial.upgradeForUnlimited': "Atualize para uso ilimitado",
  'trial.noCreditsPlaceholder': "Sem créditos disponíveis…",
  'hero.badgeHonest': "IA honesta e imparcial",
  'hero.badge60sec': "Veredicto em 60 segundos",
  'hero.badge20Lang': "20+ idiomas",
  'hero.widget.label': "Veredicto da ideia",
  'hero.widget.passed': "APROVADO",
  'hero.widget.demoIdea': "Tutor de IA para estudantes de medicina",
  'hero.widget.market': "Mercado",
  'hero.widget.demand': "Demanda",
  'hero.widget.competition': "Concorrência",
  'hero.widget.verdictReady': "Veredicto pronto · 47 seg",
  'hero.widget.riskFlagged': "Risco sinalizado",
  'hero.widget.crowdedMarket': "Mercado saturado · 4 atores",
  'hero.widget.suggestedPivot': "Pivô sugerido",
  'hero.widget.nicheBySpecialty': "Nicho por especialidade",
  'hero.widget.feasibilityGain': "+38% de viabilidade",
  'hero.widget.analysisDone': "Análise concluída",
  'hero.widget.metrics56': "5 de 6 métricas",
  'hero.stats.verdictSpeed': "Velocidade do veredicto",
  'cta.badge': "Veredicto em 60 segundos",
  'cta.subtitleEnd': "sem adivinhar.",
  'cta.signinPrompt': "Já tem uma conta? Entrar",
  'cta.trustTrial': "Teste gratuito de 7 dias",
  'cta.trustNoCard': "Sem cartão necessário",
  'cta.trustCancel': "Cancele quando quiser",
  'footer.themeLabel': "Tema:",
  'footer.lightMode': "Modo claro",
  'footer.darkMode': "Modo escuro",
  'footer.sectionProduct': "Produto",
  'footer.sectionLegal': "Legal",
  'nav.switchLight': "Mudar para modo claro",
  'nav.switchDark': "Mudar para modo escuro",
  'features.badge': "Por que IdeaVerdict",
  'features.mainFeatureLabel': "Título",
  'chatError.planRestriction': "Este recurso requer um plano superior.",
  'chatError.creditDeduction': "Falha no pagamento. Tente novamente.",
  'chatError.aiService': "O serviço de IA está temporariamente indisponível. Seus créditos não foram cobrados. Tente novamente.",
  'chatError.parseError': "Formato de resposta inesperado. Tente novamente.",
  'chatError.sessionExpired': "Sua sessão expirou. Faça login novamente.",
  'chatError.timeout': "A solicitação demorou demais. Tente novamente.",
  'chatError.generic': "Falha ao obter resposta. Tente novamente.",

  // ─── Auto-backfilled from EN (2026-05-13) ───
  // These are English fallbacks for keys that hadn't been translated to
  // "pt" yet. Replace with native translations as needed.
  'faq.badge': "FAQ",
  'trial.lowCredits': "Only {credits} credits left!",
  'trial.outOfCredits': "Out of credits",
  'trial.outOfCreditsDesc': "Upgrade to keep getting verdicts.",
  'trial.viewPlans': "View plans",
  'trial.tryDemo': "Try the demo",
  'hero.widget.crowded': "Crowded market · 4 incumbents",
  'hero.widget.nicheBySpec': "Niche by specialty",
  'hero.widget.feasibilityUp': "+38% feasibility",
  'hero.widget.fiveOfSix': "5 of 6 metrics",
  'builderReport.modalTitle': "Builder Report",
  'builderReport.modalSubtitle': "Generate a comprehensive PDF for your idea",
  'builderReport.formatLabel': "Report format",
  'builderReport.formatStandard': "Standard report",
  'builderReport.formatExec': "Executive summary",
  'builderReport.toneLabel': "Tone",
  'builderReport.toneProfessional': "Professional",
  'builderReport.toneCasual': "Casual",
  'builderReport.toneTechnical': "Technical",
  'builderReport.sectionsLabel': "Sections to include",
  'builderReport.sectionMarket': "Market analysis",
  'builderReport.sectionCompetition': "Competitive landscape",
  'builderReport.sectionFinancial': "Financial model",
  'builderReport.sectionArchitecture': "Technical architecture",
  'builderReport.sectionGTM': "Go-to-market plan",
  'builderReport.sectionRisks': "Risk register",
  'builderReport.sectionRoadmap': "Product roadmap",
  'builderReport.sectionTeam': "Team & hiring plan",
  'builderReport.actionGenerate': "Generate report",
  'builderReport.actionCancel': "Cancel",
  'builderReport.actionDownload': "Download PDF",
  'builderReport.statusGenerating': "Generating your report…",
  'builderReport.statusComplete': "Report ready",
  'builderReport.statusError': "Something went wrong. Try again.",
  'builderReport.creditsRequired': "This will use {credits} credits.",
  'builderReport.pageCount': "{pages} pages",
  'builderReport.tip1': "Tip: be specific about your target customer for sharper analysis.",
  'builderReport.tip2': "Tip: include early revenue numbers if you have them.",
  'builderReport.tip3': "Tip: mention your tech preferences if any.",
  'builderReport.errorNotEnough': "You don't have enough credits for this report.",
  'builderReport.errorUpgrade': "Upgrade to a higher plan",
  'builderReport.errorTryStandard': "Try the Standard report instead",
  'builderReport.success': "Your Builder Report is ready.",
  'builderReport.previewBadge': "Preview",
  'builderReport.previewNote': "This is a preview. Generate the full PDF to see all sections.",
  'builderReport.includesLabel': "Includes",
  'builderReport.pagesIncluded': "{pages} pages of analysis",
  'builderReport.estimatedTime': "Estimated time: {minutes} min",
  'builderReport.fullReport': "Full report",
  'builderReport.execSummary': "Executive summary",
  'pricing.builder.report': "Builder Report de 25 páginas",
  'pricing.gold.report': "Builder Report de 50 páginas",
  'pricing.platinum.report': "Builder Report de 75 páginas",
  'auth.bestValue': "Melhor valor",
  'auth.elite': "Elite",
  'builderReport.friendlyError': "Não conseguimos finalizar seu relatório desta vez. Seus créditos não foram cobrados — tente novamente em um momento.",
  'builderReport.persistHint': "Se isso continuar acontecendo, contate support@ideaverdict.ai.",
};
